var _defs, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgIllHowtotrack2(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 303,
    height: 96,
    viewBox: "0 0 303 96",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("path", {
    id: "prefix__a",
    d: "M0 0.829L136.611 0.829 136.611 86.435 0 86.435z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "prefix__c",
    d: "M0 96L302.942 96 302.942 0.269 0 0.269z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "prefix__e",
    d: "M6.49.037C3.322.037.746 2.614.746 5.782V18.01c0 3.168 2.576 5.744 5.744 5.744h12.228c3.167 0 5.745-2.576 5.745-5.744V5.782c0-3.168-2.578-5.745-5.745-5.745H6.49z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "prefix__g",
    d: "M6.49.037C3.322.037.746 2.614.746 5.782V18.01c0 3.168 2.576 5.744 5.744 5.744h12.228c3.167 0 5.745-2.576 5.745-5.744V5.782c0-3.168-2.578-5.745-5.745-5.745H6.49z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "prefix__i",
    d: "M6.49.037C3.322.037.746 2.614.746 5.782V18.01c0 3.168 2.576 5.744 5.744 5.744h12.228c3.167 0 5.745-2.576 5.745-5.744V5.782c0-3.168-2.578-5.745-5.745-5.745H6.49z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "prefix__k",
    d: "M6.49.037C3.322.037.746 2.614.746 5.782V18.01c0 3.168 2.576 5.744 5.744 5.744h12.228c3.167 0 5.745-2.576 5.745-5.744V5.782c0-3.168-2.578-5.745-5.745-5.745H6.49z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "prefix__m",
    d: "M6.49.037C3.322.037.746 2.614.746 5.782V18.01c0 3.168 2.576 5.744 5.744 5.744h12.228c3.167 0 5.745-2.576 5.745-5.744V5.782c0-3.168-2.578-5.745-5.745-5.745H6.49z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "prefix__o",
    d: "M6.49.037C3.322.037.746 2.614.746 5.782V18.01c0 3.168 2.576 5.744 5.744 5.744h12.228c3.167 0 5.745-2.576 5.745-5.744V5.782c0-3.168-2.578-5.745-5.745-5.745H6.49z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "prefix__q",
    d: "M6.49.037C3.322.037.746 2.614.746 5.782V18.01c0 3.168 2.576 5.744 5.744 5.744h12.228c3.167 0 5.745-2.576 5.745-5.744V5.782c0-3.168-2.578-5.745-5.745-5.745H6.49z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "prefix__s",
    d: "M6.49.037C3.322.037.746 2.614.746 5.782V18.01c0 3.168 2.576 5.744 5.744 5.744h12.228c3.167 0 5.745-2.576 5.745-5.744V5.782c0-3.168-2.578-5.745-5.745-5.745H6.49z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "prefix__u",
    d: "M6.49.037C3.322.037.746 2.614.746 5.782V18.01c0 3.168 2.576 5.744 5.744 5.744h12.228c3.167 0 5.745-2.576 5.745-5.744V5.782c0-3.168-2.578-5.745-5.745-5.745H6.49z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "prefix__w",
    d: "M6.49.037C3.322.037.746 2.614.746 5.782V18.01c0 3.168 2.576 5.744 5.744 5.744h12.228c3.167 0 5.745-2.576 5.745-5.744V5.782c0-3.168-2.578-5.745-5.745-5.745H6.49z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "prefix__y",
    d: "M6.49.037C3.322.037.746 2.614.746 5.782V18.01c0 3.168 2.576 5.744 5.744 5.744h12.228c3.167 0 5.745-2.576 5.745-5.744V5.782c0-3.168-2.578-5.745-5.745-5.745H6.49z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "prefix__A",
    d: "M6.49.037C3.322.037.746 2.614.746 5.782V18.01c0 3.168 2.576 5.744 5.744 5.744h12.228c3.167 0 5.745-2.576 5.745-5.744V5.782c0-3.168-2.578-5.745-5.745-5.745H6.49z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "prefix__C",
    d: "M6.49.037C3.322.037.746 2.614.746 5.782V18.01c0 3.168 2.576 5.744 5.744 5.744h12.228c3.167 0 5.745-2.576 5.745-5.744V5.782c0-3.168-2.578-5.745-5.745-5.745H6.49z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "prefix__E",
    d: "M6.49.037C3.322.037.746 2.614.746 5.782V18.01c0 3.168 2.576 5.744 5.744 5.744h12.228c3.167 0 5.745-2.576 5.745-5.744V5.782c0-3.168-2.578-5.745-5.745-5.745H6.49z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "prefix__G",
    d: "M6.49.037C3.322.037.746 2.614.746 5.782V18.01c0 3.168 2.576 5.744 5.744 5.744h12.228c3.167 0 5.745-2.576 5.745-5.744V5.782c0-3.168-2.578-5.745-5.745-5.745H6.49z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "prefix__I",
    d: "M6.49.037C3.322.037.746 2.614.746 5.782V18.01c0 3.168 2.576 5.744 5.744 5.744h12.228c3.167 0 5.745-2.576 5.745-5.744V5.782c0-3.168-2.578-5.745-5.745-5.745H6.49z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "prefix__K",
    d: "M6.49.037C3.322.037.746 2.614.746 5.782V18.01c0 3.168 2.576 5.744 5.744 5.744h12.228c3.167 0 5.745-2.576 5.745-5.744V5.782c0-3.168-2.578-5.745-5.745-5.745H6.49z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "prefix__M",
    d: "M6.49.037C3.322.037.746 2.614.746 5.782V18.01c0 3.168 2.576 5.744 5.744 5.744h12.228c3.167 0 5.745-2.576 5.745-5.744V5.782c0-3.168-2.578-5.745-5.745-5.745H6.49z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "prefix__O",
    d: "M6.49.037C3.322.037.746 2.614.746 5.782V18.01c0 3.168 2.576 5.744 5.744 5.744h12.228c3.167 0 5.745-2.576 5.745-5.744V5.782c0-3.168-2.578-5.745-5.745-5.745H6.49z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "prefix__Q",
    d: "M6.49.037C3.322.037.746 2.614.746 5.782V18.01c0 3.168 2.576 5.744 5.744 5.744h12.228c3.167 0 5.745-2.576 5.745-5.744V5.782c0-3.168-2.578-5.745-5.745-5.745H6.49z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "prefix__S",
    d: "M6.49.037C3.322.037.746 2.614.746 5.782V18.01c0 3.168 2.576 5.744 5.744 5.744h12.228c3.167 0 5.745-2.576 5.745-5.744V5.782c0-3.168-2.578-5.745-5.745-5.745H6.49z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "prefix__U",
    d: "M6.49.037C3.322.037.746 2.614.746 5.782V18.01c0 3.168 2.576 5.744 5.744 5.744h12.228c3.167 0 5.745-2.576 5.745-5.744V5.782c0-3.168-2.578-5.745-5.745-5.745H6.49z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "prefix__W",
    d: "M6.49.037C3.322.037.746 2.614.746 5.782V18.01c0 3.168 2.576 5.744 5.744 5.744h12.228c3.167 0 5.745-2.576 5.745-5.744V5.782c0-3.168-2.578-5.745-5.745-5.745H6.49z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "prefix__Y",
    d: "M6.49.037C3.322.037.746 2.614.746 5.782V18.01c0 3.168 2.576 5.744 5.744 5.744h12.228c3.167 0 5.745-2.576 5.745-5.744V5.782c0-3.168-2.578-5.745-5.745-5.745H6.49z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "prefix__aa",
    d: "M6.49.037C3.322.037.746 2.614.746 5.782V18.01c0 3.168 2.576 5.744 5.744 5.744h12.228c3.167 0 5.745-2.576 5.745-5.744V5.782c0-3.168-2.578-5.745-5.745-5.745H6.49z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "prefix__ac",
    d: "M6.49.037C3.322.037.746 2.614.746 5.782V18.01c0 3.168 2.576 5.744 5.744 5.744h12.228c3.167 0 5.745-2.576 5.745-5.744V5.782c0-3.168-2.578-5.745-5.745-5.745H6.49z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "prefix__ae",
    d: "M6.49.037C3.322.037.746 2.614.746 5.782V18.01c0 3.168 2.576 5.744 5.744 5.744h12.228c3.167 0 5.745-2.576 5.745-5.744V5.782c0-3.168-2.578-5.745-5.745-5.745H6.49z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "prefix__ag",
    d: "M6.49.037C3.322.037.746 2.614.746 5.782V18.01c0 3.168 2.576 5.744 5.744 5.744h12.228c3.167 0 5.745-2.576 5.745-5.744V5.782c0-3.168-2.578-5.745-5.745-5.745H6.49z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "prefix__ai",
    d: "M6.49.037C3.322.037.746 2.614.746 5.782V18.01c0 3.168 2.576 5.744 5.744 5.744h12.228c3.167 0 5.745-2.576 5.745-5.744V5.782c0-3.168-2.578-5.745-5.745-5.745H6.49z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "prefix__ak",
    d: "M6.49.037C3.322.037.746 2.614.746 5.782V18.01c0 3.168 2.576 5.744 5.744 5.744h12.228c3.167 0 5.745-2.576 5.745-5.744V5.782c0-3.168-2.578-5.745-5.745-5.745H6.49z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "prefix__am",
    d: "M6.49.037C3.322.037.746 2.614.746 5.782V18.01c0 3.168 2.576 5.744 5.744 5.744h12.228c3.167 0 5.745-2.576 5.745-5.744V5.782c0-3.168-2.578-5.745-5.745-5.745H6.49z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "prefix__ao",
    d: "M6.49.037C3.322.037.746 2.614.746 5.782V18.01c0 3.168 2.576 5.744 5.744 5.744h12.228c3.167 0 5.745-2.576 5.745-5.744V5.782c0-3.168-2.578-5.745-5.745-5.745H6.49z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "prefix__aq",
    d: "M6.49.037C3.322.037.746 2.614.746 5.782V18.01c0 3.168 2.576 5.744 5.744 5.744h12.228c3.167 0 5.745-2.576 5.745-5.744V5.782c0-3.168-2.578-5.745-5.745-5.745H6.49z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "prefix__as",
    d: "M6.49.037C3.322.037.746 2.614.746 5.782V18.01c0 3.168 2.576 5.744 5.744 5.744h12.228c3.167 0 5.745-2.576 5.745-5.744V5.782c0-3.168-2.578-5.745-5.745-5.745H6.49z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "prefix__au",
    d: "M6.49.037C3.322.037.746 2.614.746 5.782V18.01c0 3.168 2.576 5.744 5.744 5.744h12.228c3.167 0 5.745-2.576 5.745-5.744V5.782c0-3.168-2.578-5.745-5.745-5.745H6.49z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "prefix__aw",
    d: "M6.49.037C3.322.037.746 2.614.746 5.782V18.01c0 3.168 2.576 5.744 5.744 5.744h12.228c3.167 0 5.745-2.576 5.745-5.744V5.782c0-3.168-2.578-5.745-5.745-5.745H6.49z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "prefix__ay",
    d: "M6.49.037C3.322.037.746 2.614.746 5.782V18.01c0 3.168 2.576 5.744 5.744 5.744h12.228c3.167 0 5.745-2.576 5.745-5.744V5.782c0-3.168-2.578-5.745-5.745-5.745H6.49z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "prefix__aA",
    d: "M6.49.037C3.322.037.746 2.614.746 5.782V18.01c0 3.168 2.576 5.744 5.744 5.744h12.228c3.167 0 5.745-2.576 5.745-5.744V5.782c0-3.168-2.578-5.745-5.745-5.745H6.49z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "prefix__aC",
    d: "M6.49.037C3.322.037.746 2.614.746 5.782V18.01c0 3.168 2.576 5.744 5.744 5.744h12.228c3.167 0 5.745-2.576 5.745-5.744V5.782c0-3.168-2.578-5.745-5.745-5.745H6.49z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "prefix__aE",
    d: "M6.49.037C3.322.037.746 2.614.746 5.782V18.01c0 3.168 2.576 5.744 5.744 5.744h12.228c3.167 0 5.745-2.576 5.745-5.744V5.782c0-3.168-2.578-5.745-5.745-5.745H6.49z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "prefix__aG",
    d: "M6.49.037C3.322.037.746 2.614.746 5.782V18.01c0 3.168 2.576 5.744 5.744 5.744h12.228c3.167 0 5.745-2.576 5.745-5.744V5.782c0-3.168-2.578-5.745-5.745-5.745H6.49z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "prefix__aI",
    d: "M6.49.037C3.322.037.746 2.614.746 5.782V18.01c0 3.168 2.576 5.744 5.744 5.744h12.228c3.167 0 5.745-2.576 5.745-5.744V5.782c0-3.168-2.578-5.745-5.745-5.745H6.49z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "prefix__aK",
    d: "M6.49.037C3.322.037.746 2.614.746 5.782V18.01c0 3.168 2.576 5.744 5.744 5.744h12.228c3.167 0 5.745-2.576 5.745-5.744V5.782c0-3.168-2.578-5.745-5.745-5.745H6.49z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "prefix__aM",
    d: "M6.49.037C3.322.037.746 2.614.746 5.782V18.01c0 3.168 2.576 5.744 5.744 5.744h12.228c3.167 0 5.745-2.576 5.745-5.744V5.782c0-3.168-2.578-5.745-5.745-5.745H6.49z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "prefix__aO",
    d: "M6.49.037C3.322.037.746 2.614.746 5.782V18.01c0 3.168 2.576 5.744 5.744 5.744h12.228c3.167 0 5.745-2.576 5.745-5.744V5.782c0-3.168-2.578-5.745-5.745-5.745H6.49z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "prefix__aQ",
    d: "M6.49.037C3.322.037.746 2.614.746 5.782V18.01c0 3.168 2.576 5.744 5.744 5.744h12.228c3.167 0 5.745-2.576 5.745-5.744V5.782c0-3.168-2.578-5.745-5.745-5.745H6.49z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "prefix__aS",
    d: "M6.49.037C3.322.037.746 2.614.746 5.782V18.01c0 3.168 2.576 5.744 5.744 5.744h12.228c3.167 0 5.745-2.576 5.745-5.744V5.782c0-3.168-2.578-5.745-5.745-5.745H6.49z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "prefix__aU",
    d: "M6.49.037C3.322.037.746 2.614.746 5.782V18.01c0 3.168 2.576 5.744 5.744 5.744h12.228c3.167 0 5.745-2.576 5.745-5.744V5.782c0-3.168-2.578-5.745-5.745-5.745H6.49z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "prefix__aW",
    d: "M6.49.037C3.322.037.746 2.614.746 5.782V18.01c0 3.168 2.576 5.744 5.744 5.744h12.228c3.167 0 5.745-2.576 5.745-5.744V5.782c0-3.168-2.578-5.745-5.745-5.745H6.49z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "prefix__aY",
    d: "M6.49.037C3.322.037.746 2.614.746 5.782V18.01c0 3.168 2.576 5.744 5.744 5.744h12.228c3.167 0 5.745-2.576 5.745-5.744V5.782c0-3.168-2.578-5.745-5.745-5.745H6.49z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "prefix__ba",
    d: "M6.49.037C3.322.037.746 2.614.746 5.782V18.01c0 3.168 2.576 5.744 5.744 5.744h12.228c3.167 0 5.745-2.576 5.745-5.744V5.782c0-3.168-2.578-5.745-5.745-5.745H6.49z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "prefix__bc",
    d: "M6.49.037C3.322.037.746 2.614.746 5.782V18.01c0 3.168 2.576 5.744 5.744 5.744h12.228c3.167 0 5.745-2.576 5.745-5.744V5.782c0-3.168-2.578-5.745-5.745-5.745H6.49z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "prefix__be",
    d: "M6.49.037C3.322.037.746 2.614.746 5.782V18.01c0 3.168 2.576 5.744 5.744 5.744h12.228c3.167 0 5.745-2.576 5.745-5.744V5.782c0-3.168-2.578-5.745-5.745-5.745H6.49z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "prefix__bg",
    d: "M6.49.037C3.322.037.746 2.614.746 5.782V18.01c0 3.168 2.576 5.744 5.744 5.744h12.228c3.167 0 5.745-2.576 5.745-5.744V5.782c0-3.168-2.578-5.745-5.745-5.745H6.49z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "prefix__bi",
    d: "M6.49.037C3.322.037.746 2.614.746 5.782V18.01c0 3.168 2.576 5.744 5.744 5.744h12.228c3.167 0 5.745-2.576 5.745-5.744V5.782c0-3.168-2.578-5.745-5.745-5.745H6.49z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "prefix__bk",
    d: "M6.49.037C3.322.037.746 2.614.746 5.782V18.01c0 3.168 2.576 5.744 5.744 5.744h12.228c3.167 0 5.745-2.576 5.745-5.744V5.782c0-3.168-2.578-5.745-5.745-5.745H6.49z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "prefix__bm",
    d: "M6.49.037C3.322.037.746 2.614.746 5.782V18.01c0 3.168 2.576 5.744 5.744 5.744h12.228c3.167 0 5.745-2.576 5.745-5.744V5.782c0-3.168-2.578-5.745-5.745-5.745H6.49z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "prefix__bo",
    d: "M6.49.037C3.322.037.746 2.614.746 5.782V18.01c0 3.168 2.576 5.744 5.744 5.744h12.228c3.167 0 5.745-2.576 5.745-5.744V5.782c0-3.168-2.578-5.745-5.745-5.745H6.49z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "prefix__bq",
    d: "M6.49.037C3.322.037.746 2.614.746 5.782V18.01c0 3.168 2.576 5.744 5.744 5.744h12.228c3.167 0 5.745-2.576 5.745-5.744V5.782c0-3.168-2.578-5.745-5.745-5.745H6.49z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "prefix__bs",
    d: "M6.49.037C3.322.037.746 2.614.746 5.782V18.01c0 3.168 2.576 5.744 5.744 5.744h12.228c3.167 0 5.745-2.576 5.745-5.744V5.782c0-3.168-2.578-5.745-5.745-5.745H6.49z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "prefix__bu",
    d: "M6.49.037C3.322.037.746 2.614.746 5.782V18.01c0 3.168 2.576 5.744 5.744 5.744h12.228c3.167 0 5.745-2.576 5.745-5.744V5.782c0-3.168-2.578-5.745-5.745-5.745H6.49z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "prefix__bw",
    d: "M6.49.037C3.322.037.746 2.614.746 5.782V18.01c0 3.168 2.576 5.744 5.744 5.744h12.228c3.167 0 5.745-2.576 5.745-5.744V5.782c0-3.168-2.578-5.745-5.745-5.745H6.49z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "prefix__by",
    d: "M6.49.037C3.322.037.746 2.614.746 5.782V18.01c0 3.168 2.576 5.744 5.744 5.744h12.228c3.167 0 5.745-2.576 5.745-5.744V5.782c0-3.168-2.578-5.745-5.745-5.745H6.49z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "prefix__bA",
    d: "M6.49.037C3.322.037.746 2.614.746 5.782V18.01c0 3.168 2.576 5.744 5.744 5.744h12.228c3.167 0 5.745-2.576 5.745-5.744V5.782c0-3.168-2.578-5.745-5.745-5.745H6.49z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "prefix__bC",
    d: "M6.49.037C3.322.037.746 2.614.746 5.782V18.01c0 3.168 2.576 5.744 5.744 5.744h12.228c3.167 0 5.745-2.576 5.745-5.744V5.782c0-3.168-2.578-5.745-5.745-5.745H6.49z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "prefix__bE",
    d: "M6.49.037C3.322.037.746 2.614.746 5.782V18.01c0 3.168 2.576 5.744 5.744 5.744h12.228c3.167 0 5.745-2.576 5.745-5.744V5.782c0-3.168-2.578-5.745-5.745-5.745H6.49z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "prefix__bG",
    d: "M6.49.037C3.322.037.746 2.614.746 5.782V18.01c0 3.168 2.576 5.744 5.744 5.744h12.228c3.167 0 5.745-2.576 5.745-5.744V5.782c0-3.168-2.578-5.745-5.745-5.745H6.49z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "prefix__bI",
    d: "M6.49.037C3.322.037.746 2.614.746 5.782V18.01c0 3.168 2.576 5.744 5.744 5.744h12.228c3.167 0 5.745-2.576 5.745-5.744V5.782c0-3.168-2.578-5.745-5.745-5.745H6.49z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "prefix__bK",
    d: "M6.49.037C3.322.037.746 2.614.746 5.782V18.01c0 3.168 2.576 5.744 5.744 5.744h12.228c3.167 0 5.745-2.576 5.745-5.744V5.782c0-3.168-2.578-5.745-5.745-5.745H6.49z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "prefix__bM",
    d: "M6.49.037C3.322.037.746 2.614.746 5.782V18.01c0 3.168 2.576 5.744 5.744 5.744h12.228c3.167 0 5.745-2.576 5.745-5.744V5.782c0-3.168-2.578-5.745-5.745-5.745H6.49z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "prefix__bO",
    d: "M6.49.037C3.322.037.746 2.614.746 5.782V18.01c0 3.168 2.576 5.744 5.744 5.744h12.228c3.167 0 5.745-2.576 5.745-5.744V5.782c0-3.168-2.578-5.745-5.745-5.745H6.49z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "prefix__bQ",
    d: "M6.49.037C3.322.037.746 2.614.746 5.782V18.01c0 3.168 2.576 5.744 5.744 5.744h12.228c3.167 0 5.745-2.576 5.745-5.744V5.782c0-3.168-2.578-5.745-5.745-5.745H6.49z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "prefix__bS",
    d: "M6.49.037C3.322.037.746 2.614.746 5.782V18.01c0 3.168 2.576 5.744 5.744 5.744h12.228c3.167 0 5.745-2.576 5.745-5.744V5.782c0-3.168-2.578-5.745-5.745-5.745H6.49z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "prefix__bU",
    d: "M6.49.037C3.322.037.746 2.614.746 5.782V18.01c0 3.168 2.576 5.744 5.744 5.744h12.228c3.167 0 5.745-2.576 5.745-5.744V5.782c0-3.168-2.578-5.745-5.745-5.745H6.49z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "prefix__bW",
    d: "M6.49.037C3.322.037.746 2.614.746 5.782V18.01c0 3.168 2.576 5.744 5.744 5.744h12.228c3.167 0 5.745-2.576 5.745-5.744V5.782c0-3.168-2.578-5.745-5.745-5.745H6.49z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "prefix__bY",
    d: "M6.49.037C3.322.037.746 2.614.746 5.782V18.01c0 3.168 2.576 5.744 5.744 5.744h12.228c3.167 0 5.745-2.576 5.745-5.744V5.782c0-3.168-2.578-5.745-5.745-5.745H6.49z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "prefix__ca",
    d: "M6.49.037C3.322.037.746 2.614.746 5.782V18.01c0 3.168 2.576 5.744 5.744 5.744h12.228c3.167 0 5.745-2.576 5.745-5.744V5.782c0-3.168-2.578-5.745-5.745-5.745H6.49z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "prefix__cc",
    d: "M6.49.037C3.322.037.746 2.614.746 5.782V18.01c0 3.168 2.576 5.744 5.744 5.744h12.228c3.167 0 5.745-2.576 5.745-5.744V5.782c0-3.168-2.578-5.745-5.745-5.745H6.49z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "prefix__ce",
    d: "M6.49.037C3.322.037.746 2.614.746 5.782V18.01c0 3.168 2.576 5.744 5.744 5.744h12.228c3.167 0 5.745-2.576 5.745-5.744V5.782c0-3.168-2.578-5.745-5.745-5.745H6.49z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "prefix__cg",
    d: "M6.49.037C3.322.037.746 2.614.746 5.782V18.01c0 3.168 2.576 5.744 5.744 5.744h12.228c3.167 0 5.745-2.576 5.745-5.744V5.782c0-3.168-2.578-5.745-5.745-5.745H6.49z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "prefix__ci",
    d: "M6.49.037C3.322.037.746 2.614.746 5.782V18.01c0 3.168 2.576 5.744 5.744 5.744h12.228c3.167 0 5.745-2.576 5.745-5.744V5.782c0-3.168-2.578-5.745-5.745-5.745H6.49z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "prefix__ck",
    d: "M6.49.037C3.322.037.746 2.614.746 5.782V18.01c0 3.168 2.576 5.744 5.744 5.744h12.228c3.167 0 5.745-2.576 5.745-5.744V5.782c0-3.168-2.578-5.745-5.745-5.745H6.49z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "prefix__cm",
    d: "M6.49.037C3.322.037.746 2.614.746 5.782V18.01c0 3.168 2.576 5.744 5.744 5.744h12.228c3.167 0 5.745-2.576 5.745-5.744V5.782c0-3.168-2.578-5.745-5.745-5.745H6.49z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "prefix__co",
    d: "M6.49.037C3.322.037.746 2.614.746 5.782V18.01c0 3.168 2.576 5.744 5.744 5.744h12.228c3.167 0 5.745-2.576 5.745-5.744V5.782c0-3.168-2.578-5.745-5.745-5.745H6.49z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "prefix__cq",
    d: "M6.49.037C3.322.037.746 2.614.746 5.782V18.01c0 3.168 2.576 5.744 5.744 5.744h12.228c3.167 0 5.745-2.576 5.745-5.744V5.782c0-3.168-2.578-5.745-5.745-5.745H6.49z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "prefix__cs",
    d: "M6.49.037C3.322.037.746 2.614.746 5.782V18.01c0 3.168 2.576 5.744 5.744 5.744h12.228c3.167 0 5.745-2.576 5.745-5.744V5.782c0-3.168-2.578-5.745-5.745-5.745H6.49z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "prefix__cu",
    d: "M6.49.037C3.322.037.746 2.614.746 5.782V18.01c0 3.168 2.576 5.744 5.744 5.744h12.228c3.167 0 5.745-2.576 5.745-5.744V5.782c0-3.168-2.578-5.745-5.745-5.745H6.49z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "prefix__cw",
    d: "M6.49.037C3.322.037.746 2.614.746 5.782V18.01c0 3.168 2.576 5.744 5.744 5.744h12.228c3.167 0 5.745-2.576 5.745-5.744V5.782c0-3.168-2.578-5.745-5.745-5.745H6.49z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "prefix__cy",
    d: "M6.49.037C3.322.037.746 2.614.746 5.782V18.01c0 3.168 2.576 5.744 5.744 5.744h12.228c3.167 0 5.745-2.576 5.745-5.744V5.782c0-3.168-2.578-5.745-5.745-5.745H6.49z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "prefix__cA",
    d: "M6.49.037C3.322.037.746 2.614.746 5.782V18.01c0 3.168 2.576 5.744 5.744 5.744h12.228c3.167 0 5.745-2.576 5.745-5.744V5.782c0-3.168-2.578-5.745-5.745-5.745H6.49z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "prefix__cC",
    d: "M6.49.037C3.322.037.746 2.614.746 5.782V18.01c0 3.168 2.576 5.744 5.744 5.744h12.228c3.167 0 5.745-2.576 5.745-5.744V5.782c0-3.168-2.578-5.745-5.745-5.745H6.49z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "prefix__cE",
    d: "M6.49.037C3.322.037.746 2.614.746 5.782V18.01c0 3.168 2.576 5.744 5.744 5.744h12.228c3.167 0 5.745-2.576 5.745-5.744V5.782c0-3.168-2.578-5.745-5.745-5.745H6.49z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "prefix__cG",
    d: "M6.49.037C3.322.037.746 2.614.746 5.782V18.01c0 3.168 2.576 5.744 5.744 5.744h12.228c3.167 0 5.745-2.576 5.745-5.744V5.782c0-3.168-2.578-5.745-5.745-5.745H6.49z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "prefix__cI",
    d: "M6.49.037C3.322.037.746 2.614.746 5.782V18.01c0 3.168 2.576 5.744 5.744 5.744h12.228c3.167 0 5.745-2.576 5.745-5.744V5.782c0-3.168-2.578-5.745-5.745-5.745H6.49z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "prefix__cK",
    d: "M6.49.037C3.322.037.746 2.614.746 5.782V18.01c0 3.168 2.576 5.744 5.744 5.744h12.228c3.167 0 5.745-2.576 5.745-5.744V5.782c0-3.168-2.578-5.745-5.745-5.745H6.49z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "prefix__cM",
    d: "M6.49.037C3.322.037.746 2.614.746 5.782V18.01c0 3.168 2.576 5.744 5.744 5.744h12.228c3.167 0 5.745-2.576 5.745-5.744V5.782c0-3.168-2.578-5.745-5.745-5.745H6.49z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "prefix__cO",
    d: "M6.49.037C3.322.037.746 2.614.746 5.782V18.01c0 3.168 2.576 5.744 5.744 5.744h12.228c3.167 0 5.745-2.576 5.745-5.744V5.782c0-3.168-2.578-5.745-5.745-5.745H6.49z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "prefix__cQ",
    d: "M0 96L302.942 96 302.942 0.269 0 0.269z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "prefix__cS",
    d: "M7.064 1.114c-1.01.354-1.332.891-1.332.891s-.322-.537-1.331-.891C2.817.557.359 1.313.359 4.078c0 3.54 5.373 6.211 5.373 6.211s5.373-2.671 5.373-6.211C11.105 1.87 9.538.943 8.1.943c-.363 0-.717.059-1.036.171z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "prefix__cU",
    d: "M1.412 1.291C.817 1.713.107 2.538.107 4.078c0 3.655 5.288 6.325 5.513 6.438.035.016.075.025.112.025.038 0 .078-.009.113-.025.226-.113 5.512-2.783 5.512-6.438 0-1.54-.709-2.365-1.303-2.787C9.197.683 7.991.521 6.98.876c-.643.225-1.033.527-1.248.739-.215-.212-.603-.514-1.246-.739C4.13.751 3.75.69 3.37.69c-.701 0-1.403.207-1.958.601zm-.8 2.787c0-1.049.378-1.869 1.091-2.375.471-.335 1.068-.51 1.663-.51.324 0 .649.052.952.158.896.316 1.197.781 1.198.785.045.074.127.119.215.12h.001c.089 0 .17-.046.216-.119.003-.005.303-.47 1.198-.786.862-.302 1.889-.163 2.616.352.713.506 1.091 1.326 1.091 2.375 0 3.066-4.36 5.521-5.121 5.926C4.971 9.6.612 7.147.612 4.078z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "prefix__cW",
    d: "M5.787.037C2.621.037.043 2.614.043 5.782V18.01c0 3.168 2.578 5.744 5.744 5.744h12.229c3.168 0 5.744-2.576 5.744-5.744V5.782c0-3.168-2.576-5.745-5.744-5.745H5.787z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "prefix__cY",
    d: "M6.192.411C3.024.411.446 2.988.446 6.155v12.228c0 3.168 2.578 5.745 5.746 5.745h12.227c3.168 0 5.744-2.577 5.744-5.745V6.155c0-3.167-2.576-5.744-5.744-5.744H6.192z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "prefix__da",
    d: "M6.192.411C3.024.411.446 2.988.446 6.155v12.228c0 3.168 2.578 5.745 5.746 5.745h12.227c3.168 0 5.744-2.577 5.744-5.745V6.155c0-3.167-2.576-5.744-5.744-5.744H6.192z"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "translate(0 -1) translate(0 .731)"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#E6E6E6",
    d: "M301.76 56.387c-.142-.457-.295-.912-.461-1.367-2.833-7.753-8.472-12.686-14.221-15.814-11.48-6.245-21.881-14.94-30.822-25.702-5.581-6.718-11.836-10.63-19.223-6.5-7.851 4.39-16.957 4.84-25.112 1.24l-2.048-.903c-21.504-9.489-45.07-9.428-66.54.175l-4.964 2.22c2.229.192 4.016 2.124 4.025 4.466v-2.399c0-1.154.945-2.1 2.099-2.1h5.817c1.154 0 2.098.946 2.098 2.1 0-1.154.946-2.1 2.1-2.1h5.816c1.155 0 2.1.946 2.1 2.1 0-1.154.944-2.1 2.099-2.1h5.816c1.154 0 2.1.946 2.1 2.1v13.351c0 .205-.039.4-.095.587v5.282c.222-.009.439-.022.665-.027v.83c.118-.148.237-.297.343-.457l.087.01v10.596c0 1.6-.461 3.156-1.313 4.438l-1.916 2.883c-.691 1.04-1.063 2.301-1.063 7.903v35.236h60.904l8.987-5.9c7.017-4.605 16.012-4.93 23.344-.846l1.314.732c20.398 11.365 44.946-7.72 38.064-30.034"
  }), /*#__PURE__*/React.createElement("g", {
    transform: "translate(0 6)"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "prefix__b",
    fill: "#fff"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#prefix__a"
  })), /*#__PURE__*/React.createElement("path", {
    fill: "#E6E6E6",
    d: "M136.61 51.035c0-5.467-.457-6.568-1.251-7.314l-2.897-2.722c-1.726-1.623-2.723-4.02-2.723-6.546V19.118c0-1.734 1.117-3.184 2.644-3.666V8.22c0-.727.187-1.413.493-2.027l-3.46 1.548c-5.706 2.553-11.84 3.128-17.734 1.738-4.978-1.173-10.12-.79-15.017.81-9.802 3.204-20.221 2.218-29.483-2.834C54.9.755 45.978-2.842 30.86 6.42 16.934 14.953 3.3 22.18.428 40.35-1.564 52.954 4.16 63.415 2.117 72.238l-.04.168c-.074.297-.136.592-.186.887-1.496 8.816 9.12 14.584 16.04 8.919 7.504-6.144 17.868-7.437 26.652-3.323L60.7 86.435h75.91v-35.4z",
    mask: "url(#prefix__b)"
  })), /*#__PURE__*/React.createElement("path", {
    fill: "#E6E6E6",
    d: "M173.009 30.997c.146 0 .284.016.43.018v-4.791c-1.133 1.818-3.118 3.029-5.379 3.029h-1.256c-1.694 0-3.236-.678-4.38-1.782-1.143 1.104-2.686 1.782-4.379 1.782h-1.256c-1.694 0-3.236-.678-4.38-1.782-.805.778-1.811 1.338-2.926 1.605-.103.653-.307 1.052-.658 1.054-1.695 2.008-4.194 3.22-6.886 3.224l-3.758.004c1.041 1.53 2.535 2.71 4.287 3.183 2.028.546 4.973 1.977 7.18 5.7 3.613-6.644 13.435-11.244 23.361-11.244"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#000",
    d: "M134.89 12.1c-.198 0-.386-.119-.464-.314-.102-.257.022-.548.278-.65 1.73-.692 3.638-.693 5.372 0 .256.102.38.393.278.65-.103.256-.395.38-.65.278-1.494-.599-3.138-.598-4.628 0-.061.024-.124.036-.186.036M169.93 12.1c-.061 0-.124-.012-.185-.036-1.492-.598-3.134-.598-4.628 0-.257.102-.547-.022-.65-.278-.102-.257.022-.548.278-.65 1.733-.693 3.64-.693 5.372 0 .256.102.38.393.278.65-.078.195-.266.314-.464.314"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#E6E6E6",
    d: "M159.501 26.985c-.459.173-.938.259-1.46.259h-1.252c-2.419 0-4.38-2.024-4.38-4.522v-8.503c0-1.313.563-2.518 1.46-3.337.23 4.263 1.273 12.745 5.632 16.103M169.516 26.985c-.46.173-.938.259-1.46.259h-1.252c-2.42 0-4.38-2.024-4.38-4.522v-8.503c0-1.313.563-2.518 1.46-3.337.23 4.263 1.273 12.745 5.632 16.103"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#FFF",
    d: "M170.163 21.302v2.82c0 .537-1.523.775-2.94.71-1.295-.02-2.526-.28-2.526-.71v-2.82c0-.452.105-.883.292-1.249.44-.926 1.357-1.57 2.441-1.57 1.523 0 2.733 1.268 2.733 2.82M160.149 21.302v2.82c0 .537-1.523.775-2.942.71-1.293-.02-2.524-.28-2.524-.71v-2.82c0-.452.105-.883.292-1.249.439-.926 1.356-1.57 2.44-1.57 1.523 0 2.734 1.268 2.734 2.82"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#000",
    d: "M149.902 12.1c-.062 0-.125-.012-.186-.036-1.492-.598-3.136-.598-4.628 0-.257.102-.547-.022-.65-.278-.102-.257.022-.548.278-.65 1.733-.693 3.639-.693 5.372 0 .256.102.38.393.278.65-.078.195-.266.314-.464.314M159.916 12.1c-.062 0-.125-.012-.186-.036-1.492-.598-3.136-.598-4.628 0-.256.102-.547-.022-.65-.278-.102-.257.022-.548.278-.65 1.733-.693 3.64-.693 5.372 0 .256.102.38.393.278.65-.078.195-.266.314-.464.314"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#E6E6E6",
    d: "M133.405 21.253h2.333c-1.309-3.616-1.755-7.774-1.895-10.37-.897.818-1.46 2.023-1.46 3.337v7.223c.32-.117.661-.19 1.022-.19"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#FFF",
    d: "M140.117 21.253c-.026-1.527-1.222-2.771-2.728-2.771-1.085 0-2.002.646-2.44 1.572-.18.352-.279.765-.287 1.199h5.455zM147.4 18.482c-1.084 0-2.001.646-2.44 1.571-.18.353-.278.766-.286 1.2h2.492c1.613 0 2.919 1.288 2.96 2.89 0-.008.007-.014.007-.021v-2.82c0-1.549-1.21-2.82-2.732-2.82"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#E6E6E6",
    d: "M145.75 21.253c-1.31-3.616-1.756-7.774-1.897-10.37-.896.818-1.459 2.023-1.459 3.337v7.033h3.355z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#000",
    d: "M168.059 7.704h-1.256c-1.693 0-3.236.679-4.38 1.783-1.142-1.104-2.684-1.783-4.38-1.783h-1.255c-1.694 0-3.236.679-4.38 1.783-1.142-1.104-2.684-1.783-4.378-1.783h-1.256c-1.694 0-3.236.679-4.38 1.783-1.144-1.104-2.686-1.783-4.38-1.783h-1.255c-3.517 0-6.38 2.926-6.38 6.52v8.509c0 .375.038.74.098 1.096.146-1.103.89-2.01 1.902-2.384v-7.22c0-2.487 1.97-4.521 4.38-4.521h1.256c2.408 0 4.379 2.034 4.379 4.52 0-2.486 1.97-4.52 4.38-4.52h1.256c2.408 0 4.379 2.034 4.379 4.52 0-2.486 1.97-4.52 4.379-4.52h1.256c2.409 0 4.38 2.034 4.38 4.52 0-2.486 1.97-4.52 4.379-4.52h1.256c2.409 0 4.38 2.034 4.38 4.52v8.509c0 2.487-1.971 4.52-4.38 4.52h-1.256c-2.408 0-4.38-2.033-4.38-4.52 0 2.487-1.97 4.52-4.38 4.52h-1.255c-2.408 0-4.38-2.033-4.38-4.52 0 1.703-.934 3.176-2.29 3.946-.063 1.146-.765 2.12-1.766 2.558 1.566-.08 2.987-.733 4.057-1.766 1.143 1.104 2.685 1.782 4.379 1.782h1.256c1.695 0 3.237-.678 4.38-1.782 1.143 1.104 2.686 1.782 4.379 1.782h1.256c3.518 0 6.38-2.924 6.38-6.52v-8.508c0-3.595-2.862-6.521-6.38-6.521"
  }), /*#__PURE__*/React.createElement("path", {
    stroke: "#000",
    d: "M170.163 21.302v2.82c0 .537-1.523.775-2.94.71-1.295-.02-2.526-.28-2.526-.71v-2.82c0-.452.105-.883.292-1.249.44-.926 1.357-1.57 2.441-1.57 1.523 0 2.733 1.268 2.733 2.82zM160.149 21.302v2.82c0 .537-1.523.775-2.942.71-1.293-.02-2.524-.28-2.524-.71v-2.82c0-.452.105-.883.292-1.249.439-.926 1.356-1.57 2.44-1.57 1.523 0 2.734 1.268 2.734 2.82zM140.117 21.253c-.026-1.527-1.222-2.771-2.728-2.771-1.085 0-2.002.646-2.44 1.572-.18.352-.279.765-.287 1.199M150.125 24.143c.001-.008.008-.014.008-.02v-2.82c0-1.55-1.21-2.82-2.733-2.82-1.085 0-2.002.644-2.44 1.57-.18.353-.278 1.176-.286 1.61"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#000",
    d: "M151.956 49.07c-.24 0-.452-.174-.492-.42-.48-2.911-1.718-5.421-1.73-5.446-1.319-1.926-3.13-3.574-5.202-4.708-.242-.132-.33-.436-.198-.68.133-.242.438-.33.68-.197 2.208 1.209 4.138 2.966 5.581 5.08.088.166 1.351 2.724 1.855 5.79.045.272-.14.53-.412.574-.027.005-.055.007-.082.007"
  }), /*#__PURE__*/React.createElement("path", {
    stroke: "#000",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 2,
    d: "M169.147 95L169.147 68.82M136.569 95L136.569 68.82"
  }), /*#__PURE__*/React.createElement("path", {
    stroke: "#000",
    d: "M141.86 21.266c-.401.567-.654 1.293-.654 2.102 0 1.297.626 2.395 1.522 2.92.356.223.773.348 1.21.348h2.733c.418 0 .668-1.472.688-3.018.023-.633.006-1.284-.052-1.85-.632-.315-1.336-.502-2.085-.502h-3.362z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#000",
    d: "M136.61 65.982c-.552 0-1-.447-1-1V52.73c0-.89-.341-1.722-.936-2.281l-2.896-2.722c-1.932-1.814-3.04-4.466-3.04-7.274V24.829c0-.978.298-1.91.859-2.695.835-1.169 2.178-1.868 3.593-1.868h12.67c2.853 0 5.173 2.38 5.173 5.306 0 4.839-3.83 8.776-8.535 8.776h-3.456c-.553 0-1-.447-1-1 0-.552.447-1 1-1h3.456c3.603 0 6.535-3.04 6.535-6.776 0-1.822-1.423-3.306-3.172-3.306H133.19c-.781 0-1.498.376-1.965 1.031-.318.445-.486.974-.486 1.532v15.624c0 2.258.878 4.379 2.408 5.816l2.897 2.723c.996.935 1.567 2.299 1.567 3.738v12.252c0 .553-.447 1-1 1M169.147 65.982c-.553 0-1-.447-1-1V52.893c0-1.504.426-2.938 1.23-4.149l1.916-2.883c.74-1.111 1.146-2.491 1.146-3.885v-26.84c0-.552.447-1 1-1 .553 0 1 .448 1 1v26.84c0 1.81-.512 3.535-1.48 4.991l-1.916 2.883c-.578.87-.896 1.95-.896 3.043v12.089c0 .553-.447 1-1 1"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#000",
    d: "M132.438 25.1c-.128 0-.256-.049-.354-.146l-1.5-1.5c-.195-.196-.195-.512 0-.708.196-.195.512-.195.708 0l1.5 1.5c.195.196.195.512 0 .708-.098.097-.226.146-.354.146"
  }), /*#__PURE__*/React.createElement("path", {
    stroke: "#000",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 2,
    d: "M164.28 54.881c5.575-3.963 7.983-8.438 8.805-10.313.236-.539.353-1.117.353-1.706V31.375"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#92A1B7",
    d: "M137.44 58.949h30.92c1.27 0 2.3 1.04 2.3 2.31v4.259c0 1.27-1.03 2.3-2.3 2.3h-30.92c-1.27 0-2.3-1.03-2.3-2.3v-4.26c0-1.27 1.03-2.31 2.3-2.31"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#ADBBD0",
    d: "M137.44 58.949h21.49c1.28 0 2.31 1.04 2.31 2.31v4.259c0 1.27-1.03 2.3-2.31 2.3h-21.49c-1.27 0-2.3-1.03-2.3-2.3v-4.26c0-1.27 1.03-2.31 2.3-2.31"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#000",
    d: "M139.825 58.953v8.867c0 1.106.896 2 2 2h13.268c1.104 0 2-.894 2-2v-8.867c0-1.104-.896-2-2-2h-13.268c-1.104 0-2 .896-2 2zm2 8.867h13.268v-8.867h-13.268v8.867z"
  }), /*#__PURE__*/React.createElement("mask", {
    id: "prefix__d",
    fill: "#fff"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#prefix__c"
  })), /*#__PURE__*/React.createElement("path", {
    fill: "#303030",
    d: "M141.825 67.82L155.093 67.82 155.093 58.953 141.825 58.953z",
    mask: "url(#prefix__d)"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#454545",
    d: "M151.471 67.82L141.825 67.82 141.825 58.953z",
    mask: "url(#prefix__d)"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#000",
    d: "M133.136 61.256v4.261c0 2.373 1.931 4.302 4.304 4.302h30.917c2.373 0 4.303-1.929 4.303-4.302v-4.26c0-2.374-1.93-4.305-4.303-4.305H137.44c-2.373 0-4.304 1.931-4.304 4.304m2 0c0-1.272 1.031-2.304 2.304-2.304h30.917c1.272 0 2.303 1.032 2.303 2.304v4.261c0 1.271-1.031 2.302-2.303 2.302H137.44c-1.273 0-2.304-1.03-2.304-2.302v-4.26M130.37 53.508c0 .234-.082.47-.249.66-2.238 2.548-3.47 5.822-3.47 9.22 0 3.398 1.232 6.673 3.47 9.221.365.416.324 1.046-.09 1.411-.416.365-1.048.324-1.412-.09-2.56-2.914-3.969-6.657-3.969-10.542 0-3.884 1.41-7.627 3.97-10.54.363-.415.995-.456 1.41-.09.226.196.34.473.34.75M122.54 79.488c0 .284-.12.566-.354.765-.42.356-1.052.303-1.41-.12-3.95-4.668-6.126-10.616-6.126-16.745 0-6.13 2.176-12.076 6.127-16.745.357-.422.988-.474 1.41-.118.42.358.474.987.117 1.409-3.646 4.31-5.654 9.798-5.654 15.454 0 5.657 2.008 11.145 5.654 15.455.16.188.236.417.236.645",
    mask: "url(#prefix__d)"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#000",
    d: "M114.7 41.06c0 .225-.076.451-.23.638-5.043 6.075-7.82 13.778-7.82 21.69 0 7.913 2.777 15.617 7.82 21.692.352.425.292 1.055-.13 1.408-.426.352-1.057.294-1.41-.13-5.339-6.434-8.28-14.59-8.28-22.97 0-8.378 2.941-16.535 8.28-22.968.353-.424.984-.483 1.41-.13.237.198.36.482.36.77M174.439 53.508c0 .234.082.47.249.66 2.238 2.548 3.47 5.822 3.47 9.22 0 3.398-1.232 6.673-3.47 9.221-.365.416-.324 1.046.09 1.411.416.365 1.048.324 1.412-.09 2.56-2.914 3.969-6.657 3.969-10.542 0-3.884-1.41-7.627-3.97-10.54-.363-.415-.995-.456-1.41-.09-.226.196-.34.473-.34.75M182.269 79.488c0 .284.12.566.354.765.42.356 1.052.303 1.41-.12 3.95-4.668 6.126-10.616 6.126-16.745 0-6.13-2.176-12.076-6.127-16.745-.357-.422-.988-.474-1.41-.118-.42.358-.474.987-.117 1.409 3.646 4.31 5.654 9.798 5.654 15.454 0 5.657-2.008 11.145-5.654 15.455-.16.188-.236.417-.236.645",
    mask: "url(#prefix__d)"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#000",
    d: "M190.109 41.06c0 .225.076.451.23.638 5.043 6.075 7.82 13.778 7.82 21.69 0 7.913-2.777 15.617-7.82 21.692-.352.425-.292 1.055.13 1.408.426.352 1.057.294 1.41-.13 5.339-6.434 8.28-14.59 8.28-22.97 0-8.378-2.941-16.535-8.28-22.968-.353-.424-.984-.483-1.41-.13-.237.198-.36.482-.36.77",
    mask: "url(#prefix__d)"
  }), /*#__PURE__*/React.createElement("path", {
    stroke: "#000",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    d: "M155.093 36.207s6.775-4.988 17.916-5.21",
    mask: "url(#prefix__d)"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#E6E6E6",
    d: "M165.969 36.6c-.466 0-.883-.327-.979-.802-.11-.54.24-1.068.782-1.178 1.094-.222 2.213-.365 3.322-.423.543-.042 1.021.394 1.052.946.028.552-.395 1.022-.947 1.052-1.011.052-2.031.182-3.031.385-.066.013-.134.02-.199.02M153.832 43.24c-.238 0-.477-.084-.667-.255-.41-.368-.446-1-.078-1.411.125-.14 3.12-3.446 8.3-5.604.511-.213 1.094.029 1.307.539.213.509-.028 1.095-.538 1.307-4.74 1.975-7.552 5.062-7.58 5.093-.197.22-.47.33-.744.33",
    mask: "url(#prefix__d)"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#000",
    d: "M136.569 91.518H48.426c-.552 0-1 .447-1 1 0 .553.448 1 1 1h88.143v-2zM241.383 91.518h-71.867v2h71.867c.553 0 1-.447 1-1 0-.553-.447-1-1-1",
    mask: "url(#prefix__d)"
  }), /*#__PURE__*/React.createElement("path", {
    stroke: "#000",
    d: "M142.394 11.803L142.394 21.252M152.457 11.803L152.457 25.94M162.424 11.803L162.424 25.94",
    mask: "url(#prefix__d)"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(0 -1) translate(58 37.731)"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "prefix__f",
    fill: "#fff"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#prefix__e"
  })), /*#__PURE__*/React.createElement("path", {
    fill: "#311CDD",
    d: "M0.745 18.151L6.349 23.755 0.745 23.755z",
    mask: "url(#prefix__f)"
  }), /*#__PURE__*/React.createElement("mask", {
    id: "prefix__h",
    fill: "#fff"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#prefix__g"
  })), /*#__PURE__*/React.createElement("path", {
    fill: "#311CDD",
    d: "M0.745 17.832L6.668 23.755 6.349 23.755 0.745 18.151z",
    mask: "url(#prefix__h)"
  }), /*#__PURE__*/React.createElement("mask", {
    id: "prefix__j",
    fill: "#fff"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#prefix__i"
  })), /*#__PURE__*/React.createElement("path", {
    fill: "#301DDD",
    d: "M0.745 17.511L6.987 23.754 6.668 23.754 0.745 17.831z",
    mask: "url(#prefix__j)"
  }), /*#__PURE__*/React.createElement("mask", {
    id: "prefix__l",
    fill: "#fff"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#prefix__k"
  })), /*#__PURE__*/React.createElement("path", {
    fill: "#301EDE",
    d: "M0.745 17.192L7.307 23.754 6.987 23.754 0.745 17.511z",
    mask: "url(#prefix__l)"
  }), /*#__PURE__*/React.createElement("mask", {
    id: "prefix__n",
    fill: "#fff"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#prefix__m"
  })), /*#__PURE__*/React.createElement("path", {
    fill: "#2F1FDE",
    d: "M0.745 16.872L7.627 23.755 7.307 23.755 0.745 17.192z",
    mask: "url(#prefix__n)"
  }), /*#__PURE__*/React.createElement("mask", {
    id: "prefix__p",
    fill: "#fff"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#prefix__o"
  })), /*#__PURE__*/React.createElement("path", {
    fill: "#2F20DE",
    d: "M0.745 16.552L7.947 23.754 7.627 23.754 0.745 16.871z",
    mask: "url(#prefix__p)"
  }), /*#__PURE__*/React.createElement("mask", {
    id: "prefix__r",
    fill: "#fff"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#prefix__q"
  })), /*#__PURE__*/React.createElement("path", {
    fill: "#2E21DF",
    d: "M0.745 16.233L8.266 23.754 7.947 23.754 0.745 16.552z",
    mask: "url(#prefix__r)"
  }), /*#__PURE__*/React.createElement("mask", {
    id: "prefix__t",
    fill: "#fff"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#prefix__s"
  })), /*#__PURE__*/React.createElement("path", {
    fill: "#2E22DF",
    d: "M0.745 15.913L8.586 23.755 8.266 23.755 0.745 16.233z",
    mask: "url(#prefix__t)"
  }), /*#__PURE__*/React.createElement("mask", {
    id: "prefix__v",
    fill: "#fff"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#prefix__u"
  })), /*#__PURE__*/React.createElement("path", {
    fill: "#2D23DF",
    d: "M0.745 15.593L8.906 23.754 8.586 23.754 0.745 15.912z",
    mask: "url(#prefix__v)"
  }), /*#__PURE__*/React.createElement("mask", {
    id: "prefix__x",
    fill: "#fff"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#prefix__w"
  })), /*#__PURE__*/React.createElement("path", {
    fill: "#2D24E0",
    d: "M0.745 15.274L9.225 23.754 8.906 23.754 0.745 15.593z",
    mask: "url(#prefix__x)"
  }), /*#__PURE__*/React.createElement("mask", {
    id: "prefix__z",
    fill: "#fff"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#prefix__y"
  })), /*#__PURE__*/React.createElement("path", {
    fill: "#2C25E0",
    d: "M0.745 14.954L9.545 23.755 9.225 23.755 0.745 15.274z",
    mask: "url(#prefix__z)"
  }), /*#__PURE__*/React.createElement("mask", {
    id: "prefix__B",
    fill: "#fff"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#prefix__A"
  })), /*#__PURE__*/React.createElement("path", {
    fill: "#2C26E1",
    d: "M0.745 14.634L9.865 23.754 9.545 23.754 0.745 14.953z",
    mask: "url(#prefix__B)"
  }), /*#__PURE__*/React.createElement("mask", {
    id: "prefix__D",
    fill: "#fff"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#prefix__C"
  })), /*#__PURE__*/React.createElement("path", {
    fill: "#2B27E1",
    d: "M0.745 14.315L10.184 23.754 9.865 23.754 0.745 14.634z",
    mask: "url(#prefix__D)"
  }), /*#__PURE__*/React.createElement("mask", {
    id: "prefix__F",
    fill: "#fff"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#prefix__E"
  })), /*#__PURE__*/React.createElement("path", {
    fill: "#2B28E1",
    d: "M0.745 13.995L10.504 23.755 10.184 23.755 0.745 14.315z",
    mask: "url(#prefix__F)"
  }), /*#__PURE__*/React.createElement("mask", {
    id: "prefix__H",
    fill: "#fff"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#prefix__G"
  })), /*#__PURE__*/React.createElement("path", {
    fill: "#2A29E2",
    d: "M0.745 13.675L10.824 23.754 10.504 23.754 0.745 13.994z",
    mask: "url(#prefix__H)"
  }), /*#__PURE__*/React.createElement("mask", {
    id: "prefix__J",
    fill: "#fff"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#prefix__I"
  })), /*#__PURE__*/React.createElement("path", {
    fill: "#2A2AE2",
    d: "M0.745 13.356L11.143 23.754 10.824 23.754 0.745 13.675z",
    mask: "url(#prefix__J)"
  }), /*#__PURE__*/React.createElement("mask", {
    id: "prefix__L",
    fill: "#fff"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#prefix__K"
  })), /*#__PURE__*/React.createElement("path", {
    fill: "#292BE2",
    d: "M0.745 13.036L11.463 23.755 11.143 23.755 0.745 13.356z",
    mask: "url(#prefix__L)"
  }), /*#__PURE__*/React.createElement("mask", {
    id: "prefix__N",
    fill: "#fff"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#prefix__M"
  })), /*#__PURE__*/React.createElement("path", {
    fill: "#292CE3",
    d: "M0.745 12.716L11.783 23.754 11.463 23.754 0.745 13.035z",
    mask: "url(#prefix__N)"
  }), /*#__PURE__*/React.createElement("mask", {
    id: "prefix__P",
    fill: "#fff"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#prefix__O"
  })), /*#__PURE__*/React.createElement("path", {
    fill: "#282DE3",
    d: "M0.745 12.397L12.102 23.754 11.783 23.754 0.745 12.716z",
    mask: "url(#prefix__P)"
  }), /*#__PURE__*/React.createElement("mask", {
    id: "prefix__R",
    fill: "#fff"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#prefix__Q"
  })), /*#__PURE__*/React.createElement("path", {
    fill: "#282EE3",
    d: "M0.745 12.077L12.422 23.755 12.102 23.755 0.745 12.397z",
    mask: "url(#prefix__R)"
  }), /*#__PURE__*/React.createElement("mask", {
    id: "prefix__T",
    fill: "#fff"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#prefix__S"
  })), /*#__PURE__*/React.createElement("path", {
    fill: "#272FE4",
    d: "M0.745 11.757L12.742 23.754 12.422 23.754 0.745 12.076z",
    mask: "url(#prefix__T)"
  }), /*#__PURE__*/React.createElement("mask", {
    id: "prefix__V",
    fill: "#fff"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#prefix__U"
  })), /*#__PURE__*/React.createElement("path", {
    fill: "#2730E4",
    d: "M0.745 11.437L13.061 23.754 12.742 23.754 0.745 11.757z",
    mask: "url(#prefix__V)"
  }), /*#__PURE__*/React.createElement("mask", {
    id: "prefix__X",
    fill: "#fff"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#prefix__W"
  })), /*#__PURE__*/React.createElement("path", {
    fill: "#2631E4",
    d: "M0.745 11.118L13.382 23.755 13.061 23.755 0.745 11.437z",
    mask: "url(#prefix__X)"
  }), /*#__PURE__*/React.createElement("mask", {
    id: "prefix__Z",
    fill: "#fff"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#prefix__Y"
  })), /*#__PURE__*/React.createElement("path", {
    fill: "#2632E5",
    d: "M0.745 10.798L13.701 23.754 13.382 23.754 0.745 11.117z",
    mask: "url(#prefix__Z)"
  }), /*#__PURE__*/React.createElement("mask", {
    id: "prefix__ab",
    fill: "#fff"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#prefix__aa"
  })), /*#__PURE__*/React.createElement("path", {
    fill: "#2533E5",
    d: "M0.745 10.478L14.02 23.754 13.701 23.754 0.745 10.798z",
    mask: "url(#prefix__ab)"
  }), /*#__PURE__*/React.createElement("mask", {
    id: "prefix__ad",
    fill: "#fff"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#prefix__ac"
  })), /*#__PURE__*/React.createElement("path", {
    fill: "#2434E5",
    d: "M0.745 10.159L14.341 23.755 14.02 23.755 0.745 10.478z",
    mask: "url(#prefix__ad)"
  }), /*#__PURE__*/React.createElement("mask", {
    id: "prefix__af",
    fill: "#fff"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#prefix__ae"
  })), /*#__PURE__*/React.createElement("path", {
    fill: "#2435E6",
    d: "M0.745 9.839L14.66 23.754 14.341 23.754 0.745 10.158z",
    mask: "url(#prefix__af)"
  }), /*#__PURE__*/React.createElement("mask", {
    id: "prefix__ah",
    fill: "#fff"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#prefix__ag"
  })), /*#__PURE__*/React.createElement("path", {
    fill: "#2336E6",
    d: "M0.745 9.519L14.979 23.754 14.66 23.754 0.745 9.839z",
    mask: "url(#prefix__ah)"
  }), /*#__PURE__*/React.createElement("mask", {
    id: "prefix__aj",
    fill: "#fff"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#prefix__ai"
  })), /*#__PURE__*/React.createElement("path", {
    fill: "#2337E6",
    d: "M0.745 9.2L15.3 23.755 14.979 23.755 0.745 9.519z",
    mask: "url(#prefix__aj)"
  }), /*#__PURE__*/React.createElement("mask", {
    id: "prefix__al",
    fill: "#fff"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#prefix__ak"
  })), /*#__PURE__*/React.createElement("path", {
    fill: "#2238E7",
    d: "M0.745 8.88L15.619 23.754 15.3 23.754 0.745 9.199z",
    mask: "url(#prefix__al)"
  }), /*#__PURE__*/React.createElement("mask", {
    id: "prefix__an",
    fill: "#fff"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#prefix__am"
  })), /*#__PURE__*/React.createElement("path", {
    fill: "#2239E7",
    d: "M0.745 8.56L15.938 23.754 15.619 23.754 0.745 8.88z",
    mask: "url(#prefix__an)"
  }), /*#__PURE__*/React.createElement("mask", {
    id: "prefix__ap",
    fill: "#fff"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#prefix__ao"
  })), /*#__PURE__*/React.createElement("path", {
    fill: "#213AE8",
    d: "M0.745 8.241L16.259 23.755 15.938 23.755 0.745 8.56z",
    mask: "url(#prefix__ap)"
  }), /*#__PURE__*/React.createElement("mask", {
    id: "prefix__ar",
    fill: "#fff"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#prefix__aq"
  })), /*#__PURE__*/React.createElement("path", {
    fill: "#213BE8",
    d: "M0.745 7.921L16.578 23.754 16.259 23.754 0.745 8.24z",
    mask: "url(#prefix__ar)"
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("mask", {
    id: "prefix__at",
    fill: "#fff"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#prefix__as"
  })), /*#__PURE__*/React.createElement("path", {
    fill: "#203CE8",
    d: "M0.745 7.601L16.897 23.754 16.578 23.754 0.745 7.921z",
    mask: "url(#prefix__at)"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("mask", {
    id: "prefix__av",
    fill: "#fff"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#prefix__au"
  })), /*#__PURE__*/React.createElement("path", {
    fill: "#203DE9",
    d: "M0.745 7.282L17.218 23.755 16.897 23.755 0.745 7.601z",
    mask: "url(#prefix__av)"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("mask", {
    id: "prefix__ax",
    fill: "#fff"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#prefix__aw"
  })), /*#__PURE__*/React.createElement("path", {
    fill: "#1F3EE9",
    d: "M0.745 6.962L17.537 23.755 17.218 23.755 0.745 7.282z",
    mask: "url(#prefix__ax)"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("mask", {
    id: "prefix__az",
    fill: "#fff"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#prefix__ay"
  })), /*#__PURE__*/React.createElement("path", {
    fill: "#1F3FE9",
    d: "M0.745 6.642L17.857 23.754 17.537 23.754 0.745 6.961z",
    mask: "url(#prefix__az)"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("mask", {
    id: "prefix__aB",
    fill: "#fff"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#prefix__aA"
  })), /*#__PURE__*/React.createElement("path", {
    fill: "#1E40EA",
    d: "M0.745 6.323L18.177 23.755 17.857 23.755 0.745 6.642z",
    mask: "url(#prefix__aB)"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("mask", {
    id: "prefix__aD",
    fill: "#fff"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#prefix__aC"
  })), /*#__PURE__*/React.createElement("path", {
    fill: "#1E41EA",
    d: "M0.745 6.003L18.496 23.755 18.177 23.755 0.745 6.322z",
    mask: "url(#prefix__aD)"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("mask", {
    id: "prefix__aF",
    fill: "#fff"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#prefix__aE"
  })), /*#__PURE__*/React.createElement("path", {
    fill: "#1D42EA",
    d: "M0.745 5.683L18.816 23.754 18.496 23.754 0.745 6.002z",
    mask: "url(#prefix__aF)"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("mask", {
    id: "prefix__aH",
    fill: "#fff"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#prefix__aG"
  })), /*#__PURE__*/React.createElement("path", {
    fill: "#1D43EB",
    d: "M0.745 5.364L19.136 23.755 18.816 23.755 0.745 5.683z",
    mask: "url(#prefix__aH)"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("mask", {
    id: "prefix__aJ",
    fill: "#fff"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#prefix__aI"
  })), /*#__PURE__*/React.createElement("path", {
    fill: "#1C44EB",
    d: "M0.745 5.043L19.455 23.755 19.136 23.755 0.745 5.364z",
    mask: "url(#prefix__aJ)"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("mask", {
    id: "prefix__aL",
    fill: "#fff"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#prefix__aK"
  })), /*#__PURE__*/React.createElement("path", {
    fill: "#1C45EB",
    d: "M0.745 4.724L19.775 23.754 19.455 23.754 0.745 5.043z",
    mask: "url(#prefix__aL)"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("mask", {
    id: "prefix__aN",
    fill: "#fff"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#prefix__aM"
  })), /*#__PURE__*/React.createElement("path", {
    fill: "#1B46EC",
    d: "M0.745 4.405L20.095 23.755 19.775 23.755 0.745 4.724z",
    mask: "url(#prefix__aN)"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("mask", {
    id: "prefix__aP",
    fill: "#fff"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#prefix__aO"
  })), /*#__PURE__*/React.createElement("path", {
    fill: "#1B47EC",
    d: "M0.745 4.085L20.414 23.755 20.095 23.755 0.745 4.404z",
    mask: "url(#prefix__aP)"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("mask", {
    id: "prefix__aR",
    fill: "#fff"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#prefix__aQ"
  })), /*#__PURE__*/React.createElement("path", {
    fill: "#1A48EC",
    d: "M0.745 3.765L20.734 23.754 20.414 23.754 0.745 4.084z",
    mask: "url(#prefix__aR)"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("mask", {
    id: "prefix__aT",
    fill: "#fff"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#prefix__aS"
  })), /*#__PURE__*/React.createElement("path", {
    fill: "#1A49ED",
    d: "M0.745 3.446L21.054 23.755 20.734 23.755 0.745 3.765z",
    mask: "url(#prefix__aT)"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("mask", {
    id: "prefix__aV",
    fill: "#fff"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#prefix__aU"
  })), /*#__PURE__*/React.createElement("path", {
    fill: "#194AED",
    d: "M0.745 3.126L21.373 23.755 21.054 23.755 0.745 3.446z",
    mask: "url(#prefix__aV)"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("mask", {
    id: "prefix__aX",
    fill: "#fff"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#prefix__aW"
  })), /*#__PURE__*/React.createElement("path", {
    fill: "#184CEE",
    d: "M0.745 2.806L21.693 23.754 21.373 23.754 0.745 3.125z",
    mask: "url(#prefix__aX)"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("mask", {
    id: "prefix__aZ",
    fill: "#fff"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#prefix__aY"
  })), /*#__PURE__*/React.createElement("path", {
    fill: "#184DEE",
    d: "M0.745 2.486L22.013 23.755 21.693 23.755 0.745 2.806z",
    mask: "url(#prefix__aZ)"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("mask", {
    id: "prefix__bb",
    fill: "#fff"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#prefix__ba"
  })), /*#__PURE__*/React.createElement("path", {
    fill: "#174EEE",
    d: "M0.745 2.167L22.333 23.755 22.013 23.755 0.745 2.486z",
    mask: "url(#prefix__bb)"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("mask", {
    id: "prefix__bd",
    fill: "#fff"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#prefix__bc"
  })), /*#__PURE__*/React.createElement("path", {
    fill: "#174FEF",
    d: "M0.745 1.847L22.652 23.754 22.333 23.754 0.745 2.166z",
    mask: "url(#prefix__bd)"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("mask", {
    id: "prefix__bf",
    fill: "#fff"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#prefix__be"
  })), /*#__PURE__*/React.createElement("path", {
    fill: "#1650EF",
    d: "M0.745 1.527L22.972 23.755 22.652 23.755 0.745 1.847z",
    mask: "url(#prefix__bf)"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("mask", {
    id: "prefix__bh",
    fill: "#fff"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#prefix__bg"
  })), /*#__PURE__*/React.createElement("path", {
    fill: "#1651EF",
    d: "M0.745 1.208L23.292 23.755 22.972 23.755 0.745 1.527z",
    mask: "url(#prefix__bh)"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("mask", {
    id: "prefix__bj",
    fill: "#fff"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#prefix__bi"
  })), /*#__PURE__*/React.createElement("path", {
    fill: "#1552F0",
    d: "M0.745 1.156L0.879 1.022 23.477 23.621 23.344 23.755 23.292 23.755 0.745 1.208z",
    mask: "url(#prefix__bj)"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("mask", {
    id: "prefix__bl",
    fill: "#fff"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#prefix__bk"
  })), /*#__PURE__*/React.createElement("path", {
    fill: "#1553F0",
    d: "M0.879 1.022L1.039 0.862 23.637 23.46 23.478 23.621z",
    mask: "url(#prefix__bl)"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("mask", {
    id: "prefix__bn",
    fill: "#fff"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#prefix__bm"
  })), /*#__PURE__*/React.createElement("path", {
    fill: "#1454F0",
    d: "M1.039 0.862L1.198 0.703 23.797 23.3 23.637 23.461z",
    mask: "url(#prefix__bn)"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("mask", {
    id: "prefix__bp",
    fill: "#fff"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#prefix__bo"
  })), /*#__PURE__*/React.createElement("path", {
    fill: "#1455F1",
    d: "M1.198 0.703L1.359 0.543 23.957 23.141 23.797 23.301z",
    mask: "url(#prefix__bp)"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("mask", {
    id: "prefix__br",
    fill: "#fff"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#prefix__bq"
  })), /*#__PURE__*/React.createElement("path", {
    fill: "#1356F1",
    d: "M1.359 0.542L1.519 0.383 24.117 22.98 23.958 23.142z",
    mask: "url(#prefix__br)"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("mask", {
    id: "prefix__bt",
    fill: "#fff"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#prefix__bs"
  })), /*#__PURE__*/React.createElement("path", {
    fill: "#1357F1",
    d: "M1.519 0.382L1.678 0.223 24.277 22.82 24.117 22.981z",
    mask: "url(#prefix__bt)"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("mask", {
    id: "prefix__bv",
    fill: "#fff"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#prefix__bu"
  })), /*#__PURE__*/React.createElement("path", {
    fill: "#1258F2",
    d: "M1.678 0.223L1.838 0.063 24.437 22.661 24.277 22.821z",
    mask: "url(#prefix__bv)"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("mask", {
    id: "prefix__bx",
    fill: "#fff"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#prefix__bw"
  })), /*#__PURE__*/React.createElement("path", {
    fill: "#1259F2",
    d: "M1.838 0.063L1.863 0.038 2.132 0.038 24.462 22.367 24.462 22.635 24.437 22.662z",
    mask: "url(#prefix__bx)"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("mask", {
    id: "prefix__bz",
    fill: "#fff"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#prefix__by"
  })), /*#__PURE__*/React.createElement("path", {
    fill: "#115AF2",
    d: "M2.452 0.038L24.462 22.048 24.462 22.367 2.132 0.038z",
    mask: "url(#prefix__bz)"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("mask", {
    id: "prefix__bB",
    fill: "#fff"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#prefix__bA"
  })), /*#__PURE__*/React.createElement("path", {
    fill: "#115BF3",
    d: "M2.772 0.038L24.462 21.728 24.462 22.048 2.453 0.038z",
    mask: "url(#prefix__bB)"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("mask", {
    id: "prefix__bD",
    fill: "#fff"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#prefix__bC"
  })), /*#__PURE__*/React.createElement("path", {
    fill: "#105CF3",
    d: "M3.091 0.038L24.462 21.408 24.462 21.728 2.772 0.038z",
    mask: "url(#prefix__bD)"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("mask", {
    id: "prefix__bF",
    fill: "#fff"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#prefix__bE"
  })), /*#__PURE__*/React.createElement("path", {
    fill: "#105DF3",
    d: "M3.411 0.038L24.462 21.089 24.462 21.408 3.091 0.038z",
    mask: "url(#prefix__bF)"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("mask", {
    id: "prefix__bH",
    fill: "#fff"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#prefix__bG"
  })), /*#__PURE__*/React.createElement("path", {
    fill: "#0F5EF4",
    d: "M3.731 0.038L24.462 20.768 24.462 21.089 3.412 0.038z",
    mask: "url(#prefix__bH)"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("mask", {
    id: "prefix__bJ",
    fill: "#fff"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#prefix__bI"
  })), /*#__PURE__*/React.createElement("path", {
    fill: "#0F5FF4",
    d: "M4.051 0.038L24.462 20.449 24.462 20.768 3.731 0.038z",
    mask: "url(#prefix__bJ)"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("mask", {
    id: "prefix__bL",
    fill: "#fff"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#prefix__bK"
  })), /*#__PURE__*/React.createElement("path", {
    fill: "#0E60F5",
    d: "M4.37 0.038L24.462 20.13 24.462 20.449 4.051 0.038z",
    mask: "url(#prefix__bL)"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("mask", {
    id: "prefix__bN",
    fill: "#fff"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#prefix__bM"
  })), /*#__PURE__*/React.createElement("path", {
    fill: "#0E61F5",
    d: "M4.69 0.038L24.462 19.809 24.462 20.13 4.371 0.038z",
    mask: "url(#prefix__bN)"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("mask", {
    id: "prefix__bP",
    fill: "#fff"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#prefix__bO"
  })), /*#__PURE__*/React.createElement("path", {
    fill: "#0D62F5",
    d: "M5.01 0.038L24.462 19.49 24.462 19.809 4.69 0.038z",
    mask: "url(#prefix__bP)"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("mask", {
    id: "prefix__bR",
    fill: "#fff"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#prefix__bQ"
  })), /*#__PURE__*/React.createElement("path", {
    fill: "#0D63F6",
    d: "M5.329 0.038L24.462 19.171 24.462 19.49 5.01 0.038z",
    mask: "url(#prefix__bR)"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("mask", {
    id: "prefix__bT",
    fill: "#fff"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#prefix__bS"
  })), /*#__PURE__*/React.createElement("path", {
    fill: "#0C64F6",
    d: "M5.649 0.038L24.462 18.85 24.462 19.171 5.33 0.038z",
    mask: "url(#prefix__bT)"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("mask", {
    id: "prefix__bV",
    fill: "#fff"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#prefix__bU"
  })), /*#__PURE__*/React.createElement("path", {
    fill: "#0B65F6",
    d: "M5.969 0.038L24.462 18.531 24.462 18.85 5.649 0.038z",
    mask: "url(#prefix__bV)"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("mask", {
    id: "prefix__bX",
    fill: "#fff"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#prefix__bW"
  })), /*#__PURE__*/React.createElement("path", {
    fill: "#0B66F7",
    d: "M6.288 0.038L24.462 18.212 24.462 18.531 5.969 0.038z",
    mask: "url(#prefix__bX)"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("mask", {
    id: "prefix__bZ",
    fill: "#fff"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#prefix__bY"
  })), /*#__PURE__*/React.createElement("path", {
    fill: "#0A67F7",
    d: "M6.608 0.038L24.462 17.892 24.462 18.212 6.289 0.038z",
    mask: "url(#prefix__bZ)"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("mask", {
    id: "prefix__cb",
    fill: "#fff"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#prefix__ca"
  })), /*#__PURE__*/React.createElement("path", {
    fill: "#0A68F7",
    d: "M6.928 0.038L24.462 17.572 24.462 17.892 6.608 0.038z",
    mask: "url(#prefix__cb)"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("mask", {
    id: "prefix__cd",
    fill: "#fff"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#prefix__cc"
  })), /*#__PURE__*/React.createElement("path", {
    fill: "#0969F8",
    d: "M7.247 0.038L24.462 17.253 24.462 17.572 6.928 0.038z",
    mask: "url(#prefix__cd)"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("mask", {
    id: "prefix__cf",
    fill: "#fff"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#prefix__ce"
  })), /*#__PURE__*/React.createElement("path", {
    fill: "#096AF8",
    d: "M7.567 0.038L24.463 16.933 24.463 17.253 7.248 0.038z",
    mask: "url(#prefix__cf)"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("mask", {
    id: "prefix__ch",
    fill: "#fff"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#prefix__cg"
  })), /*#__PURE__*/React.createElement("path", {
    fill: "#086BF8",
    d: "M7.887 0.038L24.462 16.613 24.462 16.933 7.567 0.038z",
    mask: "url(#prefix__ch)"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("mask", {
    id: "prefix__cj",
    fill: "#fff"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#prefix__ci"
  })), /*#__PURE__*/React.createElement("path", {
    fill: "#086CF9",
    d: "M8.206 0.038L24.462 16.294 24.462 16.613 7.887 0.038z",
    mask: "url(#prefix__cj)"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("mask", {
    id: "prefix__cl",
    fill: "#fff"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#prefix__ck"
  })), /*#__PURE__*/React.createElement("path", {
    fill: "#076DF9",
    d: "M8.526 0.038L24.463 15.974 24.463 16.294 8.207 0.038z",
    mask: "url(#prefix__cl)"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("mask", {
    id: "prefix__cn",
    fill: "#fff"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#prefix__cm"
  })), /*#__PURE__*/React.createElement("path", {
    fill: "#076EF9",
    d: "M8.846 0.038L24.462 15.654 24.462 15.974 8.526 0.038z",
    mask: "url(#prefix__cn)"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("mask", {
    id: "prefix__cp",
    fill: "#fff"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#prefix__co"
  })), /*#__PURE__*/React.createElement("path", {
    fill: "#066FFA",
    d: "M9.165 0.038L24.462 15.334 24.462 15.654 8.846 0.038z",
    mask: "url(#prefix__cp)"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("mask", {
    id: "prefix__cr",
    fill: "#fff"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#prefix__cq"
  })), /*#__PURE__*/React.createElement("path", {
    fill: "#0670FA",
    d: "M9.486 0.038L24.463 15.015 24.463 15.334 9.166 0.038z",
    mask: "url(#prefix__cr)"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("mask", {
    id: "prefix__ct",
    fill: "#fff"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#prefix__cs"
  })), /*#__PURE__*/React.createElement("path", {
    fill: "#0571FA",
    d: "M9.805 0.038L24.462 14.695 24.462 15.015 9.486 0.038z",
    mask: "url(#prefix__ct)"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("mask", {
    id: "prefix__cv",
    fill: "#fff"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#prefix__cu"
  })), /*#__PURE__*/React.createElement("path", {
    fill: "#0572FB",
    d: "M10.124 0.038L24.462 14.375 24.462 14.695 9.805 0.038z",
    mask: "url(#prefix__cv)"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("mask", {
    id: "prefix__cx",
    fill: "#fff"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#prefix__cw"
  })), /*#__PURE__*/React.createElement("path", {
    fill: "#0473FB",
    d: "M10.445 0.038L24.463 14.056 24.463 14.375 10.125 0.038z",
    mask: "url(#prefix__cx)"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("mask", {
    id: "prefix__cz",
    fill: "#fff"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#prefix__cy"
  })), /*#__PURE__*/React.createElement("path", {
    fill: "#0474FC",
    d: "M10.764 0.038L24.462 13.736 24.462 14.056 10.445 0.038z",
    mask: "url(#prefix__cz)"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("mask", {
    id: "prefix__cB",
    fill: "#fff"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#prefix__cA"
  })), /*#__PURE__*/React.createElement("path", {
    fill: "#0375FC",
    d: "M11.083 0.038L24.462 13.416 24.462 13.736 10.764 0.038z",
    mask: "url(#prefix__cB)"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("mask", {
    id: "prefix__cD",
    fill: "#fff"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#prefix__cC"
  })), /*#__PURE__*/React.createElement("path", {
    fill: "#0376FC",
    d: "M11.403 0.038L24.462 13.097 24.462 13.416 11.084 0.038z",
    mask: "url(#prefix__cD)"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("mask", {
    id: "prefix__cF",
    fill: "#fff"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#prefix__cE"
  })), /*#__PURE__*/React.createElement("path", {
    fill: "#0277FD",
    d: "M11.723 0.038L24.462 12.777 24.462 13.097 11.404 0.038z",
    mask: "url(#prefix__cF)"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("mask", {
    id: "prefix__cH",
    fill: "#fff"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#prefix__cG"
  })), /*#__PURE__*/React.createElement("path", {
    fill: "#0278FD",
    d: "M12.042 0.038L24.462 12.457 24.462 12.777 11.723 0.038z",
    mask: "url(#prefix__cH)"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("mask", {
    id: "prefix__cJ",
    fill: "#fff"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#prefix__cI"
  })), /*#__PURE__*/React.createElement("path", {
    fill: "#0179FD",
    d: "M12.363 0.038L24.462 12.138 24.462 12.457 12.043 0.038z",
    mask: "url(#prefix__cJ)"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("mask", {
    id: "prefix__cL",
    fill: "#fff"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#prefix__cK"
  })), /*#__PURE__*/React.createElement("path", {
    fill: "#017AFE",
    d: "M12.682 0.038L24.462 11.818 24.462 12.138 12.363 0.038z",
    mask: "url(#prefix__cL)"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("mask", {
    id: "prefix__cN",
    fill: "#fff"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#prefix__cM"
  })), /*#__PURE__*/React.createElement("path", {
    fill: "#007BFE",
    d: "M13.001 0.038L24.462 11.498 24.462 11.818 12.682 0.038z",
    mask: "url(#prefix__cN)"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("mask", {
    id: "prefix__cP",
    fill: "#fff"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#prefix__cO"
  })), /*#__PURE__*/React.createElement("path", {
    fill: "#007BFE",
    d: "M24.462 11.498L13.001 0.038 24.462 0.038z",
    mask: "url(#prefix__cP)"
  }))), /*#__PURE__*/React.createElement("g", {
    transform: "translate(0 -1) translate(0 .731)"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#FFF",
    d: "M73.045 46.497c-1.334-.898-4.023-.734-4.885.019 1.113.832 3.813.828 4.885-.02zm5.424 3.158c-1.286.775-2.686 1.228-4.21 1.494v-.352c.002-.768.004-1.535.01-2.302.001-.431-.084-.84-.348-1.185-.069-.09-.24-.176-.34-.155-1.507.324-3.022.404-4.55.229-.458-.053-.91-.14-1.36-.23-.198-.04-.357-.027-.427.176-.119.353-.294.708-.31 1.068-.046.897-.016 1.797-.016 2.76-.44-.098-.868-.146-1.263-.288-.892-.32-1.768-.685-2.65-1.03-.263-.102-.296-.274-.23-.534.218-.903.803-1.528 1.53-2.038.397-.28.835-.505 1.254-.755-.398-.234-.816-.454-1.207-.714-.64-.427-1.167-.965-1.455-1.697-.272-.688-.237-.766.434-1.08 1.041-.485 2.114-.873 3.25-1.075.1-.017.201-.028.342-.048.006.124.016.233.016.34-.002.778-.004 1.555-.009 2.332-.003.433.102.835.363 1.18.061.08.226.146.323.125 1.992-.43 3.981-.43 5.973 0 .097.02.261-.045.322-.126.261-.343.372-.742.37-1.176-.004-.878 0-1.757 0-2.713.565.139 1.111.222 1.618.408.87.32 1.715.705 2.57 1.06v.309c-.417 1.48-1.568 2.238-2.89 2.87l.464.243c1.168.614 2.141 1.398 2.426 2.78v.124zM63.792 54.773L62.931 54.773 62.931 55.893 62.376 55.893 62.376 53.149 63.896 53.149 63.896 53.611 62.931 53.611 62.931 54.314 63.792 54.314z"
  }), /*#__PURE__*/React.createElement("mask", {
    id: "prefix__cR",
    fill: "#fff"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#prefix__cQ"
  })), /*#__PURE__*/React.createElement("path", {
    fill: "#FFF",
    d: "M64.815 55.893L65.369 55.893 65.369 53.149 64.815 53.149zM68.136 53.611L67.458 53.611 67.458 55.893 66.902 55.893 66.902 53.611 66.235 53.611 66.235 53.149 68.136 53.149zM70.952 55.893L70.398 55.893 69.588 54.093 69.588 55.893 69.034 55.893 69.034 53.149 69.588 53.149 70.4 54.951 70.4 53.149 70.952 53.149zM73.393 54.706L72.531 54.706 72.531 55.434 73.551 55.434 73.551 55.893 71.976 55.893 71.976 53.149 73.548 53.149 73.548 53.611 72.531 53.611 72.531 54.26 73.393 54.26zM75.608 55.173c0-.112-.028-.196-.086-.254-.057-.057-.161-.116-.311-.178-.276-.104-.473-.226-.594-.367-.12-.139-.181-.305-.181-.496 0-.23.082-.417.246-.557.164-.14.372-.21.624-.21.169 0 .32.036.45.106.133.071.235.172.305.301.07.13.107.276.107.441h-.552c0-.128-.028-.225-.082-.293-.055-.067-.134-.1-.237-.1-.096 0-.172.028-.226.085-.054.057-.081.134-.081.231 0 .075.03.144.09.204.06.061.168.124.32.19.269.096.463.215.584.356.12.141.182.32.182.537 0 .238-.076.425-.228.56-.152.134-.358.201-.62.201-.177 0-.34-.036-.484-.11-.146-.072-.26-.176-.342-.312-.082-.136-.124-.296-.124-.48h.556c0 .158.03.273.092.344.062.072.162.108.302.108.193 0 .29-.103.29-.307M78.27 55.173c0-.112-.027-.196-.085-.254-.057-.057-.161-.116-.311-.178-.276-.104-.473-.226-.594-.367-.12-.139-.181-.305-.181-.496 0-.23.082-.417.246-.557.164-.14.372-.21.624-.21.169 0 .32.036.45.106.133.071.235.172.305.301.07.13.107.276.107.441h-.552c0-.128-.028-.225-.082-.293-.055-.067-.134-.1-.237-.1-.096 0-.171.028-.226.085-.054.057-.081.134-.081.231 0 .075.03.144.09.204.06.061.168.124.32.19.269.096.463.215.584.356.12.141.182.32.182.537 0 .238-.076.425-.228.56-.152.134-.358.201-.62.201-.177 0-.34-.036-.484-.11-.146-.072-.26-.176-.342-.312-.082-.136-.124-.296-.124-.48h.556c0 .158.03.273.092.344.062.072.162.108.302.108.193 0 .29-.103.29-.307",
    mask: "url(#prefix__cR)"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#000",
    d: "M76.69 36.038H64.518c-3.733 0-6.771 3.037-6.771 6.77v12.175c0 3.734 3.038 6.772 6.77 6.772h12.175c3.733 0 6.77-3.038 6.77-6.772V42.809c0-3.734-3.037-6.771-6.77-6.771m0 1c3.174 0 5.77 2.597 5.77 5.77v12.175c0 3.174-2.596 5.772-5.77 5.772H64.517c-3.175 0-5.771-2.598-5.771-5.772V42.809c0-3.174 2.596-5.771 5.77-5.771h12.175",
    mask: "url(#prefix__cR)"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#494848",
    d: "M117.84 16.908c-.253-2.934-2.723-5.244-5.719-5.244H99.892c-3.165 0-5.743 2.578-5.743 5.744v12.229c0 3.167 2.578 5.744 5.743 5.744h12.23c3.165 0 5.743-2.577 5.743-5.744v-12.23c0-.17-.004-.334-.025-.5",
    mask: "url(#prefix__cR)"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#00AFF1",
    d: "M112.121 11.664H99.892c-3.166 0-5.744 2.578-5.744 5.744v6.79c1.835-.561 3.671-1.124 5.506-1.691 6.064-1.862 12.122-3.733 18.186-5.6-.253-2.932-2.723-5.243-5.719-5.243",
    mask: "url(#prefix__cR)"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#494848",
    d: "M107.312 17.408l-.325 1.57c-.016.077.002.186-.083.213-.1.032-.148-.076-.206-.135-.326-.318-.648-.64-.971-.961-.056-.054-.113-.106-.225-.21.155.51.289.95.42 1.392.07.23.02.307-.198.359-.13.03-.19-.012-.227-.136-.2-.666-.4-1.332-.608-1.994-.05-.155 0-.218.142-.264.252-.08.465-.083.665.143.249.279.534.526.798.794.124.126.177.094.21-.063.087-.415.177-.83.267-1.242.056-.252.339-.402.595-.34.094.023.088.085.103.136.205.656.398 1.315.607 1.969.065.203-.057.229-.192.273-.145.048-.251.062-.305-.132-.13-.46-.276-.913-.415-1.37l-.052-.002M110.485 16.394c-.003.232.09.403.14.584.08.292.17.583.266.87.062.183-.05.22-.181.258-.131.038-.24.081-.294-.109-.194-.66-.395-1.316-.6-1.97-.06-.193.025-.277.19-.303.195-.03.374-.014.558.098.47.284.957.542 1.44.805.065.036.136.127.21.065.06-.05-.008-.135-.028-.2-.108-.368-.214-.736-.338-1.099-.06-.175-.004-.239.16-.292.172-.054.263-.036.318.154.176.606.364 1.208.549 1.811.04.131.104.275-.04.37-.137.091-.288.107-.45.015-.484-.278-.973-.546-1.462-.818-.137-.076-.276-.15-.438-.239M103.702 18.79c-.294.113-.598.2-.897.304-.057.02-.093.01-.124-.041-.087-.16-.128-.34-.165-.516-.01-.072.051-.118.114-.134.3-.088.588-.212.896-.248.248-.03.413.099.418.31 0 .17-.102.273-.242.325m1.104.918c-.197-.16-.398-.32-.604-.47-.154-.108-.19-.185-.016-.314.3-.222.351-.454.233-.783-.109-.294-.325-.44-.764-.434-.52.077-1.093.31-1.68.479-.087.027-.103.098-.078.176.206.68.408 1.36.624 2.04.052.172.181.166.33.115.14-.051.222-.123.17-.284-.05-.174-.097-.355-.165-.525-.077-.186-.015-.243.165-.314.3-.115.536-.093.758.138.113.113.263.186.377.299.186.186.376.19.608.104.17-.068.15-.134.042-.227M96.175 20.748c.006-.317.173-.658.52-.897.475-.33 1.018-.407 1.579-.391.133.003.275.022.242.235-.03.199-.114.244-.309.21-.382-.063-.747.027-1.084.213-.302.167-.439.436-.406.78.031.336.208.567.507.733.239.134.456.06.68.008.257-.064.492-.187.708-.342.048-.035.026-.083.017-.131-.062-.354-.108-.382-.457-.276-.091.027-.183.056-.274.085-.106.033-.193.018-.225-.104-.03-.111-.02-.203.116-.243.284-.082.564-.18.848-.257.141-.04.254-.015.293.169.047.219.119.432.192.644.051.143.013.252-.098.338-.504.385-1.068.622-1.708.587-.704-.038-1.146-.546-1.141-1.361M100.944 20.367c-.216.067-.437.135-.66.2-.144.048-.175-.024-.154-.143.04-.28.083-.557.124-.83.004-.051-.011-.123.06-.14.053-.015.084.042.114.078.192.212.377.434.573.645.083.097.062.154-.057.19m1.176.2c-.572-.592-1.14-1.184-1.717-1.767-.15-.155-.438-.067-.475.144-.123.784-.237 1.572-.355 2.377.04.04-.057.186.082.16.16-.026.366-.031.372-.284.005-.143.087-.222.23-.263.332-.088.657-.196.987-.298.077-.026.159-.047.21.036.177.267.398.149.62.082.123-.041.129-.098.046-.186M109.614 18.329c.001.18-.168.149-.273.193-.138.057-.227-.006-.27-.145-.091-.298-.183-.595-.273-.894-.114-.366-.222-.733-.338-1.1-.053-.167.049-.216.175-.242.118-.025.266-.151.334.067.213.686.42 1.374.63 2.06.005.017.008.033.014.06",
    mask: "url(#prefix__cR)"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#00AFF1",
    d: "M101.206 28.506c.247 0 .495.006.742-.002.113-.003.16.036.183.148.361 1.693 1.398 2.771 3.065 3.146 1.703.383 3.131-.179 4.246-1.525.055-.066.103-.136.152-.205.156-.226.357-.343.644-.33.381.015.763.001 1.145.004.3.002.363.093.235.365-.903 1.911-2.39 3.074-4.458 3.5-.238.048-.487.117-.717.113-.715-.012-1.435-.044-2.125-.282-2.215-.764-3.565-2.285-4.013-4.597l-.008-.042c-.042-.29-.042-.29.252-.29h.657v-.003zM110.819 25.887c-.17 0-.341-.012-.51.003-.303.025-.502-.109-.666-.357-.61-.914-1.458-1.493-2.53-1.716-.435-.09-.872-.1-1.33-.048-1.846.212-2.974 1.252-3.571 2.955l-.015.04c-.12.424-.12.424-.551.424-.396 0-.792-.005-1.188.003-.146.003-.17-.038-.153-.183.29-2.293 2.122-4.309 4.462-4.899 2.824-.713 5.746.731 6.9 3.412.13.304.093.363-.234.365-.204.002-.41.001-.614.001",
    mask: "url(#prefix__cR)"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#000",
    d: "M112.094 10.665H99.92c-3.733 0-6.771 3.037-6.771 6.77V29.61c0 3.734 3.038 6.772 6.771 6.772h12.174c3.733 0 6.771-3.038 6.771-6.772V17.436c0-3.734-3.038-6.771-6.771-6.771m0 1c3.174 0 5.771 2.597 5.771 5.77V29.61c0 3.174-2.597 5.772-5.771 5.772H99.92c-3.175 0-5.771-2.598-5.771-5.772V17.436c0-3.174 2.596-5.771 5.771-5.771h12.174",
    mask: "url(#prefix__cR)"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#FFF",
    d: "M41.23 35.129H29.17c-3.08 0-5.576-2.496-5.576-5.576V17.49c0-3.079 2.496-5.575 5.576-5.575h12.06c3.08 0 5.576 2.496 5.576 5.575v12.061c0 3.08-2.496 5.577-5.575 5.577",
    mask: "url(#prefix__cR)"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#E2E2E2",
    d: "M29.086 12.168c-2.89 0-5.24 2.352-5.24 5.24v12.229c0 2.889 2.35 5.24 5.24 5.24h12.23c2.887 0 5.238-2.352 5.238-5.24V17.408c0-2.889-2.35-5.24-5.239-5.24H29.086zm12.23 23.212h-12.23c-3.168 0-5.744-2.576-5.744-5.744V17.41c0-3.168 2.576-5.745 5.744-5.745h12.23c3.166 0 5.743 2.577 5.743 5.745v12.228c0 3.167-2.577 5.743-5.744 5.743z",
    mask: "url(#prefix__cR)"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(0 -1) translate(32 15.731)"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "prefix__cT",
    fill: "#fff"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#prefix__cS"
  })), /*#__PURE__*/React.createElement("path", {
    fill: "#FF060C",
    d: "M0.36 10.289L11.106 10.289 11.106 10.249 0.36 10.249z",
    mask: "url(#prefix__cT)"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#FF060D",
    d: "M0.36 10.249L11.106 10.249 11.106 10.201 0.36 10.201z",
    mask: "url(#prefix__cT)"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#FF070E",
    d: "M0.36 10.201L11.106 10.201 11.106 10.153 0.36 10.153z",
    mask: "url(#prefix__cT)"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#FF070F",
    d: "M0.36 10.153L11.106 10.153 11.106 10.104 0.36 10.104z",
    mask: "url(#prefix__cT)"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#FF0710",
    d: "M0.36 10.104L11.106 10.104 11.106 10.056 0.36 10.056z",
    mask: "url(#prefix__cT)"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#FF0811",
    d: "M0.36 10.056L11.106 10.056 11.106 10.008 0.36 10.008z",
    mask: "url(#prefix__cT)"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#FF0812",
    d: "M0.36 10.009L11.106 10.009 11.106 9.96 0.36 9.96z",
    mask: "url(#prefix__cT)"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#FF0913",
    d: "M0.36 9.96L11.106 9.96 11.106 9.912 0.36 9.912z",
    mask: "url(#prefix__cT)"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#FF0914",
    d: "M0.36 9.912L11.106 9.912 11.106 9.864 0.36 9.864z",
    mask: "url(#prefix__cT)"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#FF0A15",
    d: "M0.36 9.864L11.106 9.864 11.106 9.815 0.36 9.815z",
    mask: "url(#prefix__cT)"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#FF0A16",
    d: "M0.36 9.815L11.106 9.815 11.106 9.767 0.36 9.767z",
    mask: "url(#prefix__cT)"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#FF0B17",
    d: "M0.36 9.767L11.106 9.767 11.106 9.719 0.36 9.719z",
    mask: "url(#prefix__cT)"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#FF0B18",
    d: "M0.36 9.719L11.106 9.719 11.106 9.67 0.36 9.67z",
    mask: "url(#prefix__cT)"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#FF0C19",
    d: "M0.36 9.671L11.106 9.671 11.106 9.623 0.36 9.623z",
    mask: "url(#prefix__cT)"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#FF0C1A",
    d: "M0.36 9.623L11.106 9.623 11.106 9.574 0.36 9.574z",
    mask: "url(#prefix__cT)"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#FF0D1B",
    d: "M0.36 9.574L11.106 9.574 11.106 9.526 0.36 9.526z",
    mask: "url(#prefix__cT)"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#FF0D1C",
    d: "M0.36 9.526L11.106 9.526 11.106 9.478 0.36 9.478z",
    mask: "url(#prefix__cT)"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#FF0E1D",
    d: "M0.36 9.478L11.106 9.478 11.106 9.429 0.36 9.429z",
    mask: "url(#prefix__cT)"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#FF0E1E",
    d: "M0.36 9.429L11.106 9.429 11.106 9.381 0.36 9.381z",
    mask: "url(#prefix__cT)"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#FF0E1F",
    d: "M0.36 9.382L11.106 9.382 11.106 9.334 0.36 9.334z",
    mask: "url(#prefix__cT)"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#FF0F20",
    d: "M0.36 9.334L11.106 9.334 11.106 9.285 0.36 9.285z",
    mask: "url(#prefix__cT)"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#FF0F21",
    d: "M0.36 9.285L11.106 9.285 11.106 9.237 0.36 9.237z",
    mask: "url(#prefix__cT)"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#FF1022",
    d: "M0.36 9.237L11.106 9.237 11.106 9.189 0.36 9.189z",
    mask: "url(#prefix__cT)"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#FF1023",
    d: "M0.36 9.189L11.106 9.189 11.106 9.14 0.36 9.14z",
    mask: "url(#prefix__cT)"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#FF1124",
    d: "M0.36 9.14L11.106 9.14 11.106 9.092 0.36 9.092z",
    mask: "url(#prefix__cT)"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#FF1125",
    d: "M0.36 9.093L11.106 9.093 11.106 9.044 0.36 9.044z",
    mask: "url(#prefix__cT)"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#FF1226",
    d: "M0.36 9.044L11.106 9.044 11.106 8.996 0.36 8.996z",
    mask: "url(#prefix__cT)"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#FF1227",
    d: "M0.36 8.996L11.106 8.996 11.106 8.948 0.36 8.948z",
    mask: "url(#prefix__cT)"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#FF1328",
    d: "M0.36 8.948L11.106 8.948 11.106 8.899 0.36 8.899z",
    mask: "url(#prefix__cT)"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#FF1329",
    d: "M0.36 8.899L11.106 8.899 11.106 8.851 0.36 8.851z",
    mask: "url(#prefix__cT)"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#FF142A",
    d: "M0.36 8.851L11.106 8.851 11.106 8.803 0.36 8.803z",
    mask: "url(#prefix__cT)"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#FF142B",
    d: "M0.36 8.803L11.106 8.803 11.106 8.754 0.36 8.754z",
    mask: "url(#prefix__cT)"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#FF152C",
    d: "M0.36 8.755L11.106 8.755 11.106 8.707 0.36 8.707z",
    mask: "url(#prefix__cT)"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#FF152D",
    d: "M0.36 8.707L11.106 8.707 11.106 8.659 0.36 8.659z",
    mask: "url(#prefix__cT)"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#FF152E",
    d: "M0.36 8.659L11.106 8.659 11.106 8.61 0.36 8.61z",
    mask: "url(#prefix__cT)"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#FF162F",
    d: "M0.36 8.61L11.106 8.61 11.106 8.562 0.36 8.562z",
    mask: "url(#prefix__cT)"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#FF1630",
    d: "M0.36 8.562L11.106 8.562 11.106 8.514 0.36 8.514z",
    mask: "url(#prefix__cT)"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#FF1731",
    d: "M0.36 8.514L11.106 8.514 11.106 8.465 0.36 8.465z",
    mask: "url(#prefix__cT)"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#FF1732",
    d: "M0.36 8.466L11.106 8.466 11.106 8.418 0.36 8.418z",
    mask: "url(#prefix__cT)"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#FF1833",
    d: "M0.36 8.418L11.106 8.418 11.106 8.369 0.36 8.369z",
    mask: "url(#prefix__cT)"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#FF1834",
    d: "M0.36 8.369L11.106 8.369 11.106 8.321 0.36 8.321z",
    mask: "url(#prefix__cT)"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#FF1935",
    d: "M0.36 8.321L11.106 8.321 11.106 8.273 0.36 8.273z",
    mask: "url(#prefix__cT)"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#FF1936",
    d: "M0.36 8.273L11.106 8.273 11.106 8.224 0.36 8.224z",
    mask: "url(#prefix__cT)"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#FF1A37",
    d: "M0.36 8.224L11.106 8.224 11.106 8.176 0.36 8.176z",
    mask: "url(#prefix__cT)"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#FF1A38",
    d: "M0.36 8.176L11.106 8.176 11.106 8.128 0.36 8.128z",
    mask: "url(#prefix__cT)"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#FF1B39",
    d: "M0.36 8.129L11.106 8.129 11.106 8.08 0.36 8.08z",
    mask: "url(#prefix__cT)"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#FF1B3A",
    d: "M0.36 8.08L11.106 8.08 11.106 8.032 0.36 8.032z",
    mask: "url(#prefix__cT)"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#FF1C3B",
    d: "M0.36 8.032L11.106 8.032 11.106 7.984 0.36 7.984z",
    mask: "url(#prefix__cT)"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#FF1C3C",
    d: "M0.36 7.984L11.106 7.984 11.106 7.935 0.36 7.935z",
    mask: "url(#prefix__cT)"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#FF1C3D",
    d: "M0.36 7.935L11.106 7.935 11.106 7.887 0.36 7.887z",
    mask: "url(#prefix__cT)"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#FF1D3E",
    d: "M0.36 7.887L11.106 7.887 11.106 7.838 0.36 7.838z",
    mask: "url(#prefix__cT)"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#FF1D3F",
    d: "M0.36 7.839L11.106 7.839 11.106 7.791 0.36 7.791z",
    mask: "url(#prefix__cT)"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#FF1E40",
    d: "M0.36 7.791L11.106 7.791 11.106 7.743 0.36 7.743z",
    mask: "url(#prefix__cT)"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#FF1E41",
    d: "M0.36 7.743L11.106 7.743 11.106 7.694 0.36 7.694z",
    mask: "url(#prefix__cT)"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#FF1F42",
    d: "M0.36 7.694L11.106 7.694 11.106 7.646 0.36 7.646z",
    mask: "url(#prefix__cT)"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#FF1F43",
    d: "M0.36 7.646L11.106 7.646 11.106 7.598 0.36 7.598z",
    mask: "url(#prefix__cT)"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#FF2044",
    d: "M0.36 7.598L11.106 7.598 11.106 7.549 0.36 7.549z",
    mask: "url(#prefix__cT)"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#FF2045",
    d: "M0.36 7.55L11.106 7.55 11.106 7.502 0.36 7.502z",
    mask: "url(#prefix__cT)"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#FF2146",
    d: "M0.36 7.502L11.106 7.502 11.106 7.454 0.36 7.454z",
    mask: "url(#prefix__cT)"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#FF2147",
    d: "M0.36 7.454L11.106 7.454 11.106 7.405 0.36 7.405z",
    mask: "url(#prefix__cT)"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#FF2248",
    d: "M0.36 7.405L11.106 7.405 11.106 7.357 0.36 7.357z",
    mask: "url(#prefix__cT)"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#FF2249",
    d: "M0.36 7.357L11.106 7.357 11.106 7.309 0.36 7.309z",
    mask: "url(#prefix__cT)"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#FF234A",
    d: "M0.36 7.309L11.106 7.309 11.106 7.26 0.36 7.26z",
    mask: "url(#prefix__cT)"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#FF234B",
    d: "M0.36 7.26L11.106 7.26 11.106 7.212 0.36 7.212z",
    mask: "url(#prefix__cT)"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#FF234C",
    d: "M0.36 7.213L11.106 7.213 11.106 7.164 0.36 7.164z",
    mask: "url(#prefix__cT)"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#FF244D",
    d: "M0.36 7.164L11.106 7.164 11.106 7.116 0.36 7.116z",
    mask: "url(#prefix__cT)"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#FF244E",
    d: "M0.36 7.116L11.106 7.116 11.106 7.068 0.36 7.068z",
    mask: "url(#prefix__cT)"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#FF254F",
    d: "M0.36 7.068L11.106 7.068 11.106 7.019 0.36 7.019z",
    mask: "url(#prefix__cT)"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#FF2550",
    d: "M0.36 7.019L11.106 7.019 11.106 6.971 0.36 6.971z",
    mask: "url(#prefix__cT)"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#FF2651",
    d: "M0.36 6.971L11.106 6.971 11.106 6.923 0.36 6.923z",
    mask: "url(#prefix__cT)"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#FF2652",
    d: "M0.36 6.924L11.106 6.924 11.106 6.875 0.36 6.875z",
    mask: "url(#prefix__cT)"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#FF2753",
    d: "M0.36 6.875L11.106 6.875 11.106 6.827 0.36 6.827z",
    mask: "url(#prefix__cT)"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#FF2755",
    d: "M0.36 6.827L11.106 6.827 11.106 6.779 0.36 6.779z",
    mask: "url(#prefix__cT)"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#FF2856",
    d: "M0.36 6.779L11.106 6.779 11.106 6.73 0.36 6.73z",
    mask: "url(#prefix__cT)"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#FF2857",
    d: "M0.36 6.73L11.106 6.73 11.106 6.682 0.36 6.682z",
    mask: "url(#prefix__cT)"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#FF2958",
    d: "M0.36 6.682L11.106 6.682 11.106 6.633 0.36 6.633z",
    mask: "url(#prefix__cT)"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#FF2959",
    d: "M0.36 6.633L11.106 6.633 11.106 6.585 0.36 6.585z",
    mask: "url(#prefix__cT)"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#FF2A5A",
    d: "M0.36 6.586L11.106 6.586 11.106 6.538 0.36 6.538z",
    mask: "url(#prefix__cT)"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#FF2A5B",
    d: "M0.36 6.538L11.106 6.538 11.106 6.489 0.36 6.489z",
    mask: "url(#prefix__cT)"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#FF2B5C",
    d: "M0.36 6.489L11.106 6.489 11.106 6.441 0.36 6.441z",
    mask: "url(#prefix__cT)"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#FF2B5D",
    d: "M0.36 6.441L11.106 6.441 11.106 6.393 0.36 6.393z",
    mask: "url(#prefix__cT)"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#FF2B5E",
    d: "M0.36 6.393L11.106 6.393 11.106 6.344 0.36 6.344z",
    mask: "url(#prefix__cT)"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#FF2C5F",
    d: "M0.36 6.344L11.106 6.344 11.106 6.296 0.36 6.296z",
    mask: "url(#prefix__cT)"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#FF2C60",
    d: "M0.36 6.297L11.106 6.297 11.106 6.249 0.36 6.249z",
    mask: "url(#prefix__cT)"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#FF2D61",
    d: "M0.36 6.249L11.106 6.249 11.106 6.2 0.36 6.2z",
    mask: "url(#prefix__cT)"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#FF2D62",
    d: "M0.36 6.2L11.106 6.2 11.106 6.152 0.36 6.152z",
    mask: "url(#prefix__cT)"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#FF2E63",
    d: "M0.36 6.152L11.106 6.152 11.106 6.103 0.36 6.103z",
    mask: "url(#prefix__cT)"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#FF2E64",
    d: "M0.36 6.103L11.106 6.103 11.106 6.055 0.36 6.055z",
    mask: "url(#prefix__cT)"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#FF2F65",
    d: "M0.36 6.055L11.106 6.055 11.106 6.007 0.36 6.007z",
    mask: "url(#prefix__cT)"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#FF2F66",
    d: "M0.36 6.008L11.106 6.008 11.106 5.959 0.36 5.959z",
    mask: "url(#prefix__cT)"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#FF3067",
    d: "M0.36 5.959L11.106 5.959 11.106 5.911 0.36 5.911z",
    mask: "url(#prefix__cT)"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#FF3068",
    d: "M0.36 5.911L11.106 5.911 11.106 5.863 0.36 5.863z",
    mask: "url(#prefix__cT)"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#FF3169",
    d: "M0.36 5.863L11.106 5.863 11.106 5.814 0.36 5.814z",
    mask: "url(#prefix__cT)"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#FF316A",
    d: "M0.36 5.814L11.106 5.814 11.106 5.766 0.36 5.766z",
    mask: "url(#prefix__cT)"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#FF326B",
    d: "M0.36 5.766L11.106 5.766 11.106 5.718 0.36 5.718z",
    mask: "url(#prefix__cT)"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#FF326C",
    d: "M0.36 5.718L11.106 5.718 11.106 5.669 0.36 5.669z",
    mask: "url(#prefix__cT)"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#FF326D",
    d: "M0.36 5.67L11.106 5.67 11.106 5.622 0.36 5.622z",
    mask: "url(#prefix__cT)"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#FF336E",
    d: "M0.36 5.622L11.106 5.622 11.106 5.574 0.36 5.574z",
    mask: "url(#prefix__cT)"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#FF336F",
    d: "M0.36 5.574L11.106 5.574 11.106 5.525 0.36 5.525z",
    mask: "url(#prefix__cT)"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#FF3470",
    d: "M0.36 5.525L11.106 5.525 11.106 5.477 0.36 5.477z",
    mask: "url(#prefix__cT)"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#FF3471",
    d: "M0.36 5.477L11.106 5.477 11.106 5.428 0.36 5.428z",
    mask: "url(#prefix__cT)"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#FF3572",
    d: "M0.36 5.428L11.106 5.428 11.106 5.38 0.36 5.38z",
    mask: "url(#prefix__cT)"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#FF3573",
    d: "M0.36 5.381L11.106 5.381 11.106 5.333 0.36 5.333z",
    mask: "url(#prefix__cT)"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#FF3674",
    d: "M0.36 5.333L11.106 5.333 11.106 5.284 0.36 5.284z",
    mask: "url(#prefix__cT)"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#FF3675",
    d: "M0.36 5.284L11.106 5.284 11.106 5.236 0.36 5.236z",
    mask: "url(#prefix__cT)"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#FF3776",
    d: "M0.36 5.236L11.106 5.236 11.106 5.188 0.36 5.188z",
    mask: "url(#prefix__cT)"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#FF3777",
    d: "M0.36 5.188L11.106 5.188 11.106 5.139 0.36 5.139z",
    mask: "url(#prefix__cT)"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#FF3878",
    d: "M0.36 5.139L11.106 5.139 11.106 5.091 0.36 5.091z",
    mask: "url(#prefix__cT)"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#FF3879",
    d: "M0.36 5.092L11.106 5.092 11.106 5.044 0.36 5.044z",
    mask: "url(#prefix__cT)"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#FF397A",
    d: "M0.36 5.044L11.106 5.044 11.106 4.995 0.36 4.995z",
    mask: "url(#prefix__cT)"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#FF397B",
    d: "M0.36 4.995L11.106 4.995 11.106 4.947 0.36 4.947z",
    mask: "url(#prefix__cT)"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#FF397C",
    d: "M0.36 4.947L11.106 4.947 11.106 4.898 0.36 4.898z",
    mask: "url(#prefix__cT)"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#FF3A7D",
    d: "M0.36 4.898L11.106 4.898 11.106 4.85 0.36 4.85z",
    mask: "url(#prefix__cT)"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#FF3A7E",
    d: "M0.36 4.85L11.106 4.85 11.106 4.802 0.36 4.802z",
    mask: "url(#prefix__cT)"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#FF3B7F",
    d: "M0.36 4.802L11.106 4.802 11.106 4.753 0.36 4.753z",
    mask: "url(#prefix__cT)"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#FF3B80",
    d: "M0.36 4.754L11.106 4.754 11.106 4.706 0.36 4.706z",
    mask: "url(#prefix__cT)"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#FF3C81",
    d: "M0.36 4.706L11.106 4.706 11.106 4.658 0.36 4.658z",
    mask: "url(#prefix__cT)"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#FF3C82",
    d: "M0.36 4.658L11.106 4.658 11.106 4.609 0.36 4.609z",
    mask: "url(#prefix__cT)"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#FF3D83",
    d: "M0.36 4.609L11.106 4.609 11.106 4.561 0.36 4.561z",
    mask: "url(#prefix__cT)"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#FF3D84",
    d: "M0.36 4.561L11.106 4.561 11.106 4.513 0.36 4.513z",
    mask: "url(#prefix__cT)"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#FF3E85",
    d: "M0.36 4.513L11.106 4.513 11.106 4.464 0.36 4.464z",
    mask: "url(#prefix__cT)"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#FF3E86",
    d: "M0.36 4.465L11.106 4.465 11.106 4.417 0.36 4.417z",
    mask: "url(#prefix__cT)"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#FF3F87",
    d: "M0.36 4.417L11.106 4.417 11.106 4.369 0.36 4.369z",
    mask: "url(#prefix__cT)"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#FF3F88",
    d: "M0.36 4.369L11.106 4.369 11.106 4.32 0.36 4.32z",
    mask: "url(#prefix__cT)"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#FF4089",
    d: "M0.36 4.32L11.106 4.32 11.106 4.272 0.36 4.272z",
    mask: "url(#prefix__cT)"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#FF408A",
    d: "M0.36 4.272L11.106 4.272 11.106 4.223 0.36 4.223z",
    mask: "url(#prefix__cT)"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#FF408B",
    d: "M0.36 4.223L11.106 4.223 11.106 4.175 0.36 4.175z",
    mask: "url(#prefix__cT)"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#FF418C",
    d: "M0.36 4.175L11.106 4.175 11.106 4.127 0.36 4.127z",
    mask: "url(#prefix__cT)"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#FF418D",
    d: "M0.36 4.128L11.106 4.128 11.106 4.079 0.36 4.079z",
    mask: "url(#prefix__cT)"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#FF428E",
    d: "M0.36 4.079L11.106 4.079 11.106 4.031 0.36 4.031z",
    mask: "url(#prefix__cT)"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#FF428F",
    d: "M0.36 4.031L11.106 4.031 11.106 3.983 0.36 3.983z",
    mask: "url(#prefix__cT)"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#FF4390",
    d: "M0.36 3.983L11.106 3.983 11.106 3.934 0.36 3.934z",
    mask: "url(#prefix__cT)"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#FF4391",
    d: "M0.36 3.934L11.106 3.934 11.106 3.886 0.36 3.886z",
    mask: "url(#prefix__cT)"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#FF4492",
    d: "M0.36 3.886L11.106 3.886 11.106 3.838 0.36 3.838z",
    mask: "url(#prefix__cT)"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#FF4493",
    d: "M0.36 3.839L11.106 3.839 11.106 3.79 0.36 3.79z",
    mask: "url(#prefix__cT)"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#FF4594",
    d: "M0.36 3.79L11.106 3.79 11.106 3.742 0.36 3.742z",
    mask: "url(#prefix__cT)"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#FF4595",
    d: "M0.36 3.742L11.106 3.742 11.106 3.693 0.36 3.693z",
    mask: "url(#prefix__cT)"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#FF4696",
    d: "M0.36 3.693L11.106 3.693 11.106 3.645 0.36 3.645z",
    mask: "url(#prefix__cT)"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#FF4697",
    d: "M0.36 3.645L11.106 3.645 11.106 3.597 0.36 3.597z",
    mask: "url(#prefix__cT)"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#FF4798",
    d: "M0.36 3.597L11.106 3.597 11.106 3.548 0.36 3.548z",
    mask: "url(#prefix__cT)"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#FF4799",
    d: "M0.36 3.549L11.106 3.549 11.106 3.501 0.36 3.501z",
    mask: "url(#prefix__cT)"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#FF479A",
    d: "M0.36 3.501L11.106 3.501 11.106 3.453 0.36 3.453z",
    mask: "url(#prefix__cT)"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#FF489B",
    d: "M0.36 3.453L11.106 3.453 11.106 3.404 0.36 3.404z",
    mask: "url(#prefix__cT)"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#FF489C",
    d: "M0.36 3.404L11.106 3.404 11.106 3.356 0.36 3.356z",
    mask: "url(#prefix__cT)"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#FF499D",
    d: "M0.36 3.356L11.106 3.356 11.106 3.308 0.36 3.308z",
    mask: "url(#prefix__cT)"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#FF499E",
    d: "M0.36 3.308L11.106 3.308 11.106 3.259 0.36 3.259z",
    mask: "url(#prefix__cT)"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#FF4A9F",
    d: "M0.36 3.259L11.106 3.259 11.106 3.211 0.36 3.211z",
    mask: "url(#prefix__cT)"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#FF4AA0",
    d: "M0.36 3.212L11.106 3.212 11.106 3.163 0.36 3.163z",
    mask: "url(#prefix__cT)"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#FF4BA1",
    d: "M0.36 3.163L11.106 3.163 11.106 3.115 0.36 3.115z",
    mask: "url(#prefix__cT)"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#FF4BA2",
    d: "M0.36 3.115L11.106 3.115 11.106 3.067 0.36 3.067z",
    mask: "url(#prefix__cT)"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#FF4CA3",
    d: "M0.36 3.067L11.106 3.067 11.106 3.018 0.36 3.018z",
    mask: "url(#prefix__cT)"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#FF4CA4",
    d: "M0.36 3.018L11.106 3.018 11.106 2.97 0.36 2.97z",
    mask: "url(#prefix__cT)"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#FF4DA5",
    d: "M0.36 2.97L11.106 2.97 11.106 2.922 0.36 2.922z",
    mask: "url(#prefix__cT)"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#FF4DA6",
    d: "M0.36 2.923L11.106 2.923 11.106 2.874 0.36 2.874z",
    mask: "url(#prefix__cT)"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#FF4EA7",
    d: "M0.36 2.874L11.106 2.874 11.106 2.826 0.36 2.826z",
    mask: "url(#prefix__cT)"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#FF4EA8",
    d: "M.36 2.826L11.106 2.826 11.106 2.778.36 2.778zM.36 2.778L11.106 2.778 11.106.557.36.557z",
    mask: "url(#prefix__cT)"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(0 -1) translate(32 15.731)"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "prefix__cV",
    fill: "#fff"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#prefix__cU"
  })), /*#__PURE__*/React.createElement("path", {
    fill: "#FF0409",
    d: "M0.613 10.005L10.853 10.005 10.853 9.955 0.613 9.955z",
    mask: "url(#prefix__cV)"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#FF050A",
    d: "M0.613 9.955L10.853 9.955 10.853 9.896 0.613 9.896z",
    mask: "url(#prefix__cV)"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#FF050B",
    d: "M0.613 9.896L10.853 9.896 10.853 9.837 0.613 9.837z",
    mask: "url(#prefix__cV)"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#FF060C",
    d: "M0.613 9.838L10.853 9.838 10.853 9.779 0.613 9.779z",
    mask: "url(#prefix__cV)"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#FF060D",
    d: "M0.613 9.779L10.853 9.779 10.853 9.72 0.613 9.72z",
    mask: "url(#prefix__cV)"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#FF070E",
    d: "M0.613 9.721L10.853 9.721 10.853 9.662 0.613 9.662z",
    mask: "url(#prefix__cV)"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#FF070F",
    d: "M0.613 9.662L10.853 9.662 10.853 9.603 0.613 9.603z",
    mask: "url(#prefix__cV)"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#FF0710",
    d: "M0.613 9.603L10.853 9.603 10.853 9.544 0.613 9.544z",
    mask: "url(#prefix__cV)"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#FF0811",
    d: "M0.613 9.545L10.853 9.545 10.853 9.486 0.613 9.486z",
    mask: "url(#prefix__cV)"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#FF0812",
    d: "M0.613 9.486L10.853 9.486 10.853 9.426 0.613 9.426z",
    mask: "url(#prefix__cV)"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#FF0913",
    d: "M0.613 9.427L10.853 9.427 10.853 9.368 0.613 9.368z",
    mask: "url(#prefix__cV)"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#FF0914",
    d: "M0.613 9.368L10.853 9.368 10.853 9.309 0.613 9.309z",
    mask: "url(#prefix__cV)"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#FF0A15",
    d: "M0.613 9.31L10.853 9.31 10.853 9.251 0.613 9.251z",
    mask: "url(#prefix__cV)"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#FF0A16",
    d: "M0.613 9.251L10.853 9.251 10.853 9.192 0.613 9.192z",
    mask: "url(#prefix__cV)"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#FF0B17",
    d: "M0.613 9.192L10.853 9.192 10.853 9.133 0.613 9.133z",
    mask: "url(#prefix__cV)"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#FF0B18",
    d: "M0.613 9.134L10.853 9.134 10.853 9.075 0.613 9.075z",
    mask: "url(#prefix__cV)"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#FF0C19",
    d: "M0.613 9.075L10.853 9.075 10.853 9.016 0.613 9.016z",
    mask: "url(#prefix__cV)"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#FF0C1A",
    d: "M0.613 9.017L10.853 9.017 10.853 8.958 0.613 8.958z",
    mask: "url(#prefix__cV)"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#FF0D1B",
    d: "M0.613 8.958L10.853 8.958 10.853 8.899 0.613 8.899z",
    mask: "url(#prefix__cV)"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#FF0D1C",
    d: "M0.613 8.899L10.853 8.899 10.853 8.84 0.613 8.84z",
    mask: "url(#prefix__cV)"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#FF0E1D",
    d: "M0.613 8.841L10.853 8.841 10.853 8.782 0.613 8.782z",
    mask: "url(#prefix__cV)"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#FF0E1E",
    d: "M0.613 8.782L10.853 8.782 10.853 8.723 0.613 8.723z",
    mask: "url(#prefix__cV)"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#FF0E1F",
    d: "M0.613 8.724L10.853 8.724 10.853 8.665 0.613 8.665z",
    mask: "url(#prefix__cV)"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#FF0F20",
    d: "M0.613 8.665L10.853 8.665 10.853 8.606 0.613 8.606z",
    mask: "url(#prefix__cV)"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#FF0F21",
    d: "M0.613 8.606L10.853 8.606 10.853 8.547 0.613 8.547z",
    mask: "url(#prefix__cV)"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#FF1022",
    d: "M0.613 8.548L10.853 8.548 10.853 8.489 0.613 8.489z",
    mask: "url(#prefix__cV)"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#FF1023",
    d: "M0.613 8.489L10.853 8.489 10.853 8.43 0.613 8.43z",
    mask: "url(#prefix__cV)"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#FF1124",
    d: "M0.613 8.431L10.853 8.431 10.853 8.372 0.613 8.372z",
    mask: "url(#prefix__cV)"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#FF1125",
    d: "M0.613 8.372L10.853 8.372 10.853 8.313 0.613 8.313z",
    mask: "url(#prefix__cV)"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#FF1226",
    d: "M0.613 8.313L10.853 8.313 10.853 8.254 0.613 8.254z",
    mask: "url(#prefix__cV)"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#FF1227",
    d: "M0.613 8.255L10.853 8.255 10.853 8.196 0.613 8.196z",
    mask: "url(#prefix__cV)"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#FF1328",
    d: "M0.613 8.196L10.853 8.196 10.853 8.136 0.613 8.136z",
    mask: "url(#prefix__cV)"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#FF1329",
    d: "M0.613 8.137L10.853 8.137 10.853 8.078 0.613 8.078z",
    mask: "url(#prefix__cV)"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#FF142A",
    d: "M0.613 8.078L10.853 8.078 10.853 8.019 0.613 8.019z",
    mask: "url(#prefix__cV)"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#FF142B",
    d: "M0.613 8.019L10.853 8.019 10.853 7.96 0.613 7.96z",
    mask: "url(#prefix__cV)"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#FF152C",
    d: "M0.613 7.961L10.853 7.961 10.853 7.902 0.613 7.902z",
    mask: "url(#prefix__cV)"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#FF152D",
    d: "M0.613 7.902L10.853 7.902 10.853 7.843 0.613 7.843z",
    mask: "url(#prefix__cV)"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#FF152E",
    d: "M0.613 7.844L10.853 7.844 10.853 7.785 0.613 7.785z",
    mask: "url(#prefix__cV)"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#FF162F",
    d: "M0.613 7.785L10.853 7.785 10.853 7.726 0.613 7.726z",
    mask: "url(#prefix__cV)"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#FF1630",
    d: "M0.613 7.727L10.853 7.727 10.853 7.668 0.613 7.668z",
    mask: "url(#prefix__cV)"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#FF1731",
    d: "M0.613 7.668L10.853 7.668 10.853 7.609 0.613 7.609z",
    mask: "url(#prefix__cV)"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#FF1732",
    d: "M0.613 7.609L10.853 7.609 10.853 7.55 0.613 7.55z",
    mask: "url(#prefix__cV)"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#FF1833",
    d: "M0.613 7.551L10.853 7.551 10.853 7.492 0.613 7.492z",
    mask: "url(#prefix__cV)"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#FF1834",
    d: "M0.613 7.492L10.853 7.492 10.853 7.433 0.613 7.433z",
    mask: "url(#prefix__cV)"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#FF1935",
    d: "M0.613 7.434L10.853 7.434 10.853 7.375 0.613 7.375z",
    mask: "url(#prefix__cV)"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#FF1936",
    d: "M0.613 7.375L10.853 7.375 10.853 7.316 0.613 7.316z",
    mask: "url(#prefix__cV)"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#FF1A37",
    d: "M0.613 7.316L10.853 7.316 10.853 7.257 0.613 7.257z",
    mask: "url(#prefix__cV)"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#FF1A38",
    d: "M0.613 7.258L10.853 7.258 10.853 7.199 0.613 7.199z",
    mask: "url(#prefix__cV)"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#FF1B39",
    d: "M0.613 7.199L10.853 7.199 10.853 7.14 0.613 7.14z",
    mask: "url(#prefix__cV)"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#FF1B3A",
    d: "M0.613 7.141L10.853 7.141 10.853 7.082 0.613 7.082z",
    mask: "url(#prefix__cV)"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#FF1C3B",
    d: "M0.613 7.082L10.853 7.082 10.853 7.023 0.613 7.023z",
    mask: "url(#prefix__cV)"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#FF1C3C",
    d: "M0.613 7.023L10.853 7.023 10.853 6.964 0.613 6.964z",
    mask: "url(#prefix__cV)"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#FF1C3D",
    d: "M0.613 6.965L10.853 6.965 10.853 6.905 0.613 6.905z",
    mask: "url(#prefix__cV)"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#FF1D3E",
    d: "M0.613 6.905L10.853 6.905 10.853 6.846 0.613 6.846z",
    mask: "url(#prefix__cV)"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#FF1D3F",
    d: "M0.613 6.847L10.853 6.847 10.853 6.788 0.613 6.788z",
    mask: "url(#prefix__cV)"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#FF1E40",
    d: "M0.613 6.788L10.853 6.788 10.853 6.729 0.613 6.729z",
    mask: "url(#prefix__cV)"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#FF1E41",
    d: "M0.613 6.729L10.853 6.729 10.853 6.67 0.613 6.67z",
    mask: "url(#prefix__cV)"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#FF1F42",
    d: "M0.613 6.671L10.853 6.671 10.853 6.612 0.613 6.612z",
    mask: "url(#prefix__cV)"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#FF1F43",
    d: "M0.613 6.612L10.853 6.612 10.853 6.553 0.613 6.553z",
    mask: "url(#prefix__cV)"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#FF2044",
    d: "M0.613 6.554L10.853 6.554 10.853 6.495 0.613 6.495z",
    mask: "url(#prefix__cV)"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#FF2045",
    d: "M0.613 6.495L10.853 6.495 10.853 6.436 0.613 6.436z",
    mask: "url(#prefix__cV)"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#FF2146",
    d: "M0.613 6.436L10.853 6.436 10.853 6.377 0.613 6.377z",
    mask: "url(#prefix__cV)"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#FF2147",
    d: "M0.613 6.378L10.853 6.378 10.853 6.319 0.613 6.319z",
    mask: "url(#prefix__cV)"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#FF2248",
    d: "M0.613 6.319L10.853 6.319 10.853 6.26 0.613 6.26z",
    mask: "url(#prefix__cV)"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#FF2249",
    d: "M0.613 6.261L10.853 6.261 10.853 6.202 0.613 6.202z",
    mask: "url(#prefix__cV)"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#FF234A",
    d: "M0.613 6.202L10.853 6.202 10.853 6.143 0.613 6.143z",
    mask: "url(#prefix__cV)"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#FF234B",
    d: "M0.613 6.144L10.853 6.144 10.853 6.085 0.613 6.085z",
    mask: "url(#prefix__cV)"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#FF234C",
    d: "M0.613 6.085L10.853 6.085 10.853 6.026 0.613 6.026z",
    mask: "url(#prefix__cV)"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#FF244D",
    d: "M0.613 6.026L10.853 6.026 10.853 5.967 0.613 5.967z",
    mask: "url(#prefix__cV)"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#FF244E",
    d: "M0.613 5.968L10.853 5.968 10.853 5.909 0.613 5.909z",
    mask: "url(#prefix__cV)"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#FF254F",
    d: "M0.613 5.909L10.853 5.909 10.853 5.85 0.613 5.85z",
    mask: "url(#prefix__cV)"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#FF2550",
    d: "M0.613 5.851L10.853 5.851 10.853 5.792 0.613 5.792z",
    mask: "url(#prefix__cV)"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#FF2651",
    d: "M0.613 5.792L10.853 5.792 10.853 5.733 0.613 5.733z",
    mask: "url(#prefix__cV)"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#FF2652",
    d: "M0.613 5.733L10.853 5.733 10.853 5.674 0.613 5.674z",
    mask: "url(#prefix__cV)"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#FF2753",
    d: "M0.613 5.675L10.853 5.675 10.853 5.615 0.613 5.615z",
    mask: "url(#prefix__cV)"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#FF2755",
    d: "M0.613 5.615L10.853 5.615 10.853 5.556 0.613 5.556z",
    mask: "url(#prefix__cV)"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#FF2856",
    d: "M0.613 5.557L10.853 5.557 10.853 5.498 0.613 5.498z",
    mask: "url(#prefix__cV)"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#FF2857",
    d: "M0.613 5.498L10.853 5.498 10.853 5.439 0.613 5.439z",
    mask: "url(#prefix__cV)"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#FF2958",
    d: "M0.613 5.439L10.853 5.439 10.853 5.38 0.613 5.38z",
    mask: "url(#prefix__cV)"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#FF2959",
    d: "M0.613 5.381L10.853 5.381 10.853 5.322 0.613 5.322z",
    mask: "url(#prefix__cV)"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#FF2A5A",
    d: "M0.613 5.322L10.853 5.322 10.853 5.263 0.613 5.263z",
    mask: "url(#prefix__cV)"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#FF2A5B",
    d: "M0.613 5.264L10.853 5.264 10.853 5.205 0.613 5.205z",
    mask: "url(#prefix__cV)"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#FF2B5C",
    d: "M0.613 5.205L10.853 5.205 10.853 5.146 0.613 5.146z",
    mask: "url(#prefix__cV)"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#FF2B5D",
    d: "M0.613 5.146L10.853 5.146 10.853 5.087 0.613 5.087z",
    mask: "url(#prefix__cV)"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#FF2B5E",
    d: "M0.613 5.088L10.853 5.088 10.853 5.029 0.613 5.029z",
    mask: "url(#prefix__cV)"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#FF2C5F",
    d: "M0.613 5.029L10.853 5.029 10.853 4.97 0.613 4.97z",
    mask: "url(#prefix__cV)"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#FF2C60",
    d: "M0.613 4.971L10.853 4.971 10.853 4.912 0.613 4.912z",
    mask: "url(#prefix__cV)"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#FF2D61",
    d: "M0.613 4.912L10.853 4.912 10.853 4.853 0.613 4.853z",
    mask: "url(#prefix__cV)"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#FF2D62",
    d: "M0.613 4.853L10.853 4.853 10.853 4.794 0.613 4.794z",
    mask: "url(#prefix__cV)"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#FF2E63",
    d: "M0.613 4.795L10.853 4.795 10.853 4.736 0.613 4.736z",
    mask: "url(#prefix__cV)"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#FF2E64",
    d: "M0.613 4.736L10.853 4.736 10.853 4.677 0.613 4.677z",
    mask: "url(#prefix__cV)"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#FF2F65",
    d: "M0.613 4.678L10.853 4.678 10.853 4.619 0.613 4.619z",
    mask: "url(#prefix__cV)"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#FF2F66",
    d: "M0.613 4.619L10.853 4.619 10.853 4.56 0.613 4.56z",
    mask: "url(#prefix__cV)"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#FF3067",
    d: "M0.613 4.561L10.853 4.561 10.853 4.502 0.613 4.502z",
    mask: "url(#prefix__cV)"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#FF3068",
    d: "M0.613 4.502L10.853 4.502 10.853 4.443 0.613 4.443z",
    mask: "url(#prefix__cV)"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#FF3169",
    d: "M0.613 4.443L10.853 4.443 10.853 4.383 0.613 4.383z",
    mask: "url(#prefix__cV)"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#FF316A",
    d: "M0.613 4.384L10.853 4.384 10.853 4.325 0.613 4.325z",
    mask: "url(#prefix__cV)"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#FF326B",
    d: "M0.613 4.325L10.853 4.325 10.853 4.266 0.613 4.266z",
    mask: "url(#prefix__cV)"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#FF326C",
    d: "M0.613 4.267L10.853 4.267 10.853 4.208 0.613 4.208z",
    mask: "url(#prefix__cV)"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#FF326D",
    d: "M0.613 4.208L10.853 4.208 10.853 4.149 0.613 4.149z",
    mask: "url(#prefix__cV)"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#FF336E",
    d: "M0.613 4.149L10.853 4.149 10.853 4.09 0.613 4.09z",
    mask: "url(#prefix__cV)"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#FF336F",
    d: "M0.613 4.091L10.853 4.091 10.853 4.032 0.613 4.032z",
    mask: "url(#prefix__cV)"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#FF3470",
    d: "M0.613 4.032L10.853 4.032 10.853 3.973 0.613 3.973z",
    mask: "url(#prefix__cV)"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#FF3471",
    d: "M0.613 3.974L10.853 3.974 10.853 3.915 0.613 3.915z",
    mask: "url(#prefix__cV)"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#FF3572",
    d: "M0.613 3.915L10.853 3.915 10.853 3.856 0.613 3.856z",
    mask: "url(#prefix__cV)"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#FF3573",
    d: "M0.613 3.856L10.853 3.856 10.853 3.797 0.613 3.797z",
    mask: "url(#prefix__cV)"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#FF3674",
    d: "M0.613 3.798L10.853 3.798 10.853 3.739 0.613 3.739z",
    mask: "url(#prefix__cV)"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#FF3675",
    d: "M0.613 3.739L10.853 3.739 10.853 3.68 0.613 3.68z",
    mask: "url(#prefix__cV)"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#FF3776",
    d: "M0.613 3.681L10.853 3.681 10.853 3.622 0.613 3.622z",
    mask: "url(#prefix__cV)"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#FF3777",
    d: "M0.613 3.622L10.853 3.622 10.853 3.563 0.613 3.563z",
    mask: "url(#prefix__cV)"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#FF3878",
    d: "M0.613 3.563L10.853 3.563 10.853 3.504 0.613 3.504z",
    mask: "url(#prefix__cV)"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#FF3879",
    d: "M0.613 3.505L10.853 3.505 10.853 3.446 0.613 3.446z",
    mask: "url(#prefix__cV)"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#FF397A",
    d: "M0.613 3.446L10.853 3.446 10.853 3.387 0.613 3.387z",
    mask: "url(#prefix__cV)"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#FF397B",
    d: "M0.613 3.388L10.853 3.388 10.853 3.329 0.613 3.329z",
    mask: "url(#prefix__cV)"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#FF397C",
    d: "M0.613 3.329L10.853 3.329 10.853 3.27 0.613 3.27z",
    mask: "url(#prefix__cV)"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#FF3A7D",
    d: "M0.613 3.27L10.853 3.27 10.853 3.211 0.613 3.211z",
    mask: "url(#prefix__cV)"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#FF3A7E",
    d: "M0.613 3.212L10.853 3.212 10.853 3.153 0.613 3.153z",
    mask: "url(#prefix__cV)"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#FF3B7F",
    d: "M0.613 3.153L10.853 3.153 10.853 3.093 0.613 3.093z",
    mask: "url(#prefix__cV)"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#FF3B80",
    d: "M0.613 3.094L10.853 3.094 10.853 3.035 0.613 3.035z",
    mask: "url(#prefix__cV)"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#FF3C81",
    d: "M0.613 3.035L10.853 3.035 10.853 2.976 0.613 2.976z",
    mask: "url(#prefix__cV)"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#FF3C82",
    d: "M0.613 2.977L10.853 2.977 10.853 2.918 0.613 2.918z",
    mask: "url(#prefix__cV)"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#FF3D83",
    d: "M0.613 2.918L10.853 2.918 10.853 2.859 0.613 2.859z",
    mask: "url(#prefix__cV)"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#FF3D84",
    d: "M0.613 2.859L10.853 2.859 10.853 2.8 0.613 2.8z",
    mask: "url(#prefix__cV)"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#FF3E85",
    d: "M0.613 2.801L10.853 2.801 10.853 2.742 0.613 2.742z",
    mask: "url(#prefix__cV)"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#FF3E86",
    d: "M0.613 2.742L10.853 2.742 10.853 2.683 0.613 2.683z",
    mask: "url(#prefix__cV)"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#FF3F87",
    d: "M0.613 2.684L10.853 2.684 10.853 2.625 0.613 2.625z",
    mask: "url(#prefix__cV)"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#FF3F88",
    d: "M0.613 2.625L10.853 2.625 10.853 2.566 0.613 2.566z",
    mask: "url(#prefix__cV)"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#FF4089",
    d: "M0.613 2.566L10.853 2.566 10.853 2.507 0.613 2.507z",
    mask: "url(#prefix__cV)"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#FF408A",
    d: "M0.613 2.508L10.853 2.508 10.853 2.449 0.613 2.449z",
    mask: "url(#prefix__cV)"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#FF408B",
    d: "M0.613 2.449L10.853 2.449 10.853 2.39 0.613 2.39z",
    mask: "url(#prefix__cV)"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#FF418C",
    d: "M0.613 2.391L10.853 2.391 10.853 2.332 0.613 2.332z",
    mask: "url(#prefix__cV)"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#FF418D",
    d: "M0.613 2.332L10.853 2.332 10.853 2.273 0.613 2.273z",
    mask: "url(#prefix__cV)"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#FF428E",
    d: "M0.613 2.273L10.853 2.273 10.853 2.214 0.613 2.214z",
    mask: "url(#prefix__cV)"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#FF428F",
    d: "M0.613 2.215L10.853 2.215 10.853 2.156 0.613 2.156z",
    mask: "url(#prefix__cV)"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#FF4390",
    d: "M0.613 2.156L10.853 2.156 10.853 2.097 0.613 2.097z",
    mask: "url(#prefix__cV)"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#FF4391",
    d: "M0.613 2.098L10.853 2.098 10.853 2.039 0.613 2.039z",
    mask: "url(#prefix__cV)"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#FF4492",
    d: "M0.613 2.039L10.853 2.039 10.853 1.98 0.613 1.98z",
    mask: "url(#prefix__cV)"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#FF4493",
    d: "M0.613 1.98L10.853 1.98 10.853 1.921 0.613 1.921z",
    mask: "url(#prefix__cV)"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#FF4594",
    d: "M0.613 1.922L10.853 1.922 10.853 1.862 0.613 1.862z",
    mask: "url(#prefix__cV)"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#FF4595",
    d: "M0.613 1.862L10.853 1.862 10.853 1.803 0.613 1.803z",
    mask: "url(#prefix__cV)"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#FF4696",
    d: "M0.613 1.804L10.853 1.804 10.853 1.745 0.613 1.745z",
    mask: "url(#prefix__cV)"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#FF4697",
    d: "M0.613 1.745L10.853 1.745 10.853 1.686 0.613 1.686z",
    mask: "url(#prefix__cV)"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#FF4798",
    d: "M0.613 1.686L10.853 1.686 10.853 1.627 0.613 1.627z",
    mask: "url(#prefix__cV)"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#FF4799",
    d: "M0.613 1.628L10.853 1.628 10.853 1.569 0.613 1.569z",
    mask: "url(#prefix__cV)"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#FF479A",
    d: "M0.613 1.569L10.853 1.569 10.853 1.51 0.613 1.51z",
    mask: "url(#prefix__cV)"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#FF489B",
    d: "M0.613 1.511L10.853 1.511 10.853 1.452 0.613 1.452z",
    mask: "url(#prefix__cV)"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#FF489C",
    d: "M0.613 1.452L10.853 1.452 10.853 1.393 0.613 1.393z",
    mask: "url(#prefix__cV)"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#FF499D",
    d: "M0.613 1.394L10.853 1.394 10.853 1.335 0.613 1.335z",
    mask: "url(#prefix__cV)"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#FF499E",
    d: "M0.613 1.335L10.853 1.335 10.853 1.276 0.613 1.276z",
    mask: "url(#prefix__cV)"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#FF4A9F",
    d: "M0.613 1.276L10.853 1.276 10.853 1.217 0.613 1.217z",
    mask: "url(#prefix__cV)"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#FF4AA0",
    d: "M0.613 1.218L10.853 1.218 10.853 1.159 0.613 1.159z",
    mask: "url(#prefix__cV)"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#FF4BA1",
    d: "M0.613 1.159L10.853 1.159 10.853 1.1 0.613 1.1z",
    mask: "url(#prefix__cV)"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#FF4BA2",
    d: "M0.613 1.1L10.853 1.1 10.853 1.049 0.613 1.049z",
    mask: "url(#prefix__cV)"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "red",
    d: "M.108 10.54h11.25H.108zM.108 10.541L11.358 10.541 11.358 10.482.108 10.482z",
    mask: "url(#prefix__cV)"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#FF0001",
    d: "M0.108 10.482L11.358 10.482 11.358 10.423 0.108 10.423z",
    mask: "url(#prefix__cV)"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#FF0102",
    d: "M0.108 10.424L11.358 10.424 11.358 10.365 0.108 10.365z",
    mask: "url(#prefix__cV)"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#FF0103",
    d: "M0.108 10.365L11.358 10.365 11.358 10.306 0.108 10.306z",
    mask: "url(#prefix__cV)"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#FF0204",
    d: "M0.108 10.307L11.358 10.307 11.358 10.248 0.108 10.248z",
    mask: "url(#prefix__cV)"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#FF0205",
    d: "M0.108 10.248L11.358 10.248 11.358 10.189 0.108 10.189z",
    mask: "url(#prefix__cV)"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#FF0306",
    d: "M0.108 10.189L11.358 10.189 11.358 10.13 0.108 10.13z",
    mask: "url(#prefix__cV)"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#FF0307",
    d: "M0.108 10.131L11.358 10.131 11.358 10.072 0.108 10.072z",
    mask: "url(#prefix__cV)"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#FF0408",
    d: "M0.108 10.072L11.358 10.072 11.358 10.013 0.108 10.013z",
    mask: "url(#prefix__cV)"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#FF0409",
    d: "M0.108 10.014L11.358 10.014 11.358 9.955 0.108 9.955z",
    mask: "url(#prefix__cV)"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#FF050A",
    d: "M0.108 9.955L11.358 9.955 11.358 9.896 0.108 9.896z",
    mask: "url(#prefix__cV)"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#FF050B",
    d: "M0.108 9.896L11.358 9.896 11.358 9.837 0.108 9.837z",
    mask: "url(#prefix__cV)"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#FF060C",
    d: "M0.108 9.838L11.358 9.838 11.358 9.779 0.108 9.779z",
    mask: "url(#prefix__cV)"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#FF060D",
    d: "M0.108 9.779L11.358 9.779 11.358 9.72 0.108 9.72z",
    mask: "url(#prefix__cV)"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#FF070E",
    d: "M0.108 9.721L11.358 9.721 11.358 9.662 0.108 9.662z",
    mask: "url(#prefix__cV)"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#FF070F",
    d: "M0.108 9.662L11.358 9.662 11.358 9.603 0.108 9.603z",
    mask: "url(#prefix__cV)"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#FF0710",
    d: "M0.108 9.603L11.358 9.603 11.358 9.544 0.108 9.544z",
    mask: "url(#prefix__cV)"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#FF0811",
    d: "M0.108 9.545L11.358 9.545 11.358 9.486 0.108 9.486z",
    mask: "url(#prefix__cV)"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#FF0812",
    d: "M0.108 9.486L11.358 9.486 11.358 9.426 0.108 9.426z",
    mask: "url(#prefix__cV)"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#FF0913",
    d: "M0.108 9.427L11.358 9.427 11.358 9.368 0.108 9.368z",
    mask: "url(#prefix__cV)"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#FF0914",
    d: "M0.108 9.368L11.358 9.368 11.358 9.309 0.108 9.309z",
    mask: "url(#prefix__cV)"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#FF0A15",
    d: "M0.108 9.31L11.358 9.31 11.358 9.251 0.108 9.251z",
    mask: "url(#prefix__cV)"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#FF0A16",
    d: "M0.108 9.251L11.358 9.251 11.358 9.192 0.108 9.192z",
    mask: "url(#prefix__cV)"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#FF0B17",
    d: "M0.108 9.192L11.358 9.192 11.358 9.133 0.108 9.133z",
    mask: "url(#prefix__cV)"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#FF0B18",
    d: "M0.108 9.134L11.358 9.134 11.358 9.075 0.108 9.075z",
    mask: "url(#prefix__cV)"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#FF0C19",
    d: "M0.108 9.075L11.358 9.075 11.358 9.016 0.108 9.016z",
    mask: "url(#prefix__cV)"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#FF0C1A",
    d: "M0.108 9.017L11.358 9.017 11.358 8.958 0.108 8.958z",
    mask: "url(#prefix__cV)"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#FF0D1B",
    d: "M0.108 8.958L11.358 8.958 11.358 8.899 0.108 8.899z",
    mask: "url(#prefix__cV)"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#FF0D1C",
    d: "M0.108 8.899L11.358 8.899 11.358 8.84 0.108 8.84z",
    mask: "url(#prefix__cV)"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#FF0E1D",
    d: "M0.108 8.841L11.358 8.841 11.358 8.782 0.108 8.782z",
    mask: "url(#prefix__cV)"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#FF0E1E",
    d: "M0.108 8.782L11.358 8.782 11.358 8.723 0.108 8.723z",
    mask: "url(#prefix__cV)"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#FF0E1F",
    d: "M0.108 8.724L11.358 8.724 11.358 8.665 0.108 8.665z",
    mask: "url(#prefix__cV)"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#FF0F20",
    d: "M0.108 8.665L11.358 8.665 11.358 8.606 0.108 8.606z",
    mask: "url(#prefix__cV)"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#FF0F21",
    d: "M0.108 8.606L11.358 8.606 11.358 8.547 0.108 8.547z",
    mask: "url(#prefix__cV)"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#FF1022",
    d: "M0.108 8.548L11.358 8.548 11.358 8.489 0.108 8.489z",
    mask: "url(#prefix__cV)"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#FF1023",
    d: "M0.108 8.489L11.358 8.489 11.358 8.43 0.108 8.43z",
    mask: "url(#prefix__cV)"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#FF1124",
    d: "M0.108 8.431L11.358 8.431 11.358 8.372 0.108 8.372z",
    mask: "url(#prefix__cV)"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#FF1125",
    d: "M0.108 8.372L11.358 8.372 11.358 8.313 0.108 8.313z",
    mask: "url(#prefix__cV)"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#FF1226",
    d: "M0.108 8.313L11.358 8.313 11.358 8.254 0.108 8.254z",
    mask: "url(#prefix__cV)"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#FF1227",
    d: "M0.108 8.255L11.358 8.255 11.358 8.196 0.108 8.196z",
    mask: "url(#prefix__cV)"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#FF1328",
    d: "M0.108 8.196L11.358 8.196 11.358 8.136 0.108 8.136z",
    mask: "url(#prefix__cV)"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#FF1329",
    d: "M0.108 8.137L11.358 8.137 11.358 8.078 0.108 8.078z",
    mask: "url(#prefix__cV)"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#FF142A",
    d: "M0.108 8.078L11.358 8.078 11.358 8.019 0.108 8.019z",
    mask: "url(#prefix__cV)"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#FF142B",
    d: "M0.108 8.019L11.358 8.019 11.358 7.96 0.108 7.96z",
    mask: "url(#prefix__cV)"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#FF152C",
    d: "M0.108 7.961L11.358 7.961 11.358 7.902 0.108 7.902z",
    mask: "url(#prefix__cV)"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#FF152D",
    d: "M0.108 7.902L11.358 7.902 11.358 7.843 0.108 7.843z",
    mask: "url(#prefix__cV)"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#FF152E",
    d: "M0.108 7.844L11.358 7.844 11.358 7.785 0.108 7.785z",
    mask: "url(#prefix__cV)"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#FF162F",
    d: "M0.108 7.785L11.358 7.785 11.358 7.726 0.108 7.726z",
    mask: "url(#prefix__cV)"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#FF1630",
    d: "M0.108 7.727L11.358 7.727 11.358 7.668 0.108 7.668z",
    mask: "url(#prefix__cV)"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#FF1731",
    d: "M0.108 7.668L11.358 7.668 11.358 7.609 0.108 7.609z",
    mask: "url(#prefix__cV)"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#FF1732",
    d: "M0.108 7.609L11.358 7.609 11.358 7.55 0.108 7.55z",
    mask: "url(#prefix__cV)"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#FF1833",
    d: "M0.108 7.551L11.358 7.551 11.358 7.492 0.108 7.492z",
    mask: "url(#prefix__cV)"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#FF1834",
    d: "M0.108 7.492L11.358 7.492 11.358 7.433 0.108 7.433z",
    mask: "url(#prefix__cV)"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#FF1935",
    d: "M0.108 7.434L11.358 7.434 11.358 7.375 0.108 7.375z",
    mask: "url(#prefix__cV)"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#FF1936",
    d: "M0.108 7.375L11.358 7.375 11.358 7.316 0.108 7.316z",
    mask: "url(#prefix__cV)"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#FF1A37",
    d: "M0.108 7.316L11.358 7.316 11.358 7.257 0.108 7.257z",
    mask: "url(#prefix__cV)"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#FF1A38",
    d: "M0.108 7.258L11.358 7.258 11.358 7.199 0.108 7.199z",
    mask: "url(#prefix__cV)"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#FF1B39",
    d: "M0.108 7.199L11.358 7.199 11.358 7.14 0.108 7.14z",
    mask: "url(#prefix__cV)"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#FF1B3A",
    d: "M0.108 7.141L11.358 7.141 11.358 7.082 0.108 7.082z",
    mask: "url(#prefix__cV)"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#FF1C3B",
    d: "M0.108 7.082L11.358 7.082 11.358 7.023 0.108 7.023z",
    mask: "url(#prefix__cV)"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#FF1C3C",
    d: "M0.108 7.023L11.358 7.023 11.358 6.964 0.108 6.964z",
    mask: "url(#prefix__cV)"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#FF1C3D",
    d: "M0.108 6.965L11.358 6.965 11.358 6.905 0.108 6.905z",
    mask: "url(#prefix__cV)"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#FF1D3E",
    d: "M0.108 6.905L11.358 6.905 11.358 6.846 0.108 6.846z",
    mask: "url(#prefix__cV)"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#FF1D3F",
    d: "M0.108 6.847L11.358 6.847 11.358 6.788 0.108 6.788z",
    mask: "url(#prefix__cV)"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#FF1E40",
    d: "M0.108 6.788L11.358 6.788 11.358 6.729 0.108 6.729z",
    mask: "url(#prefix__cV)"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#FF1E41",
    d: "M0.108 6.729L11.358 6.729 11.358 6.67 0.108 6.67z",
    mask: "url(#prefix__cV)"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#FF1F42",
    d: "M0.108 6.671L11.358 6.671 11.358 6.612 0.108 6.612z",
    mask: "url(#prefix__cV)"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#FF1F43",
    d: "M0.108 6.612L11.358 6.612 11.358 6.553 0.108 6.553z",
    mask: "url(#prefix__cV)"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#FF2044",
    d: "M0.108 6.554L11.358 6.554 11.358 6.495 0.108 6.495z",
    mask: "url(#prefix__cV)"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#FF2045",
    d: "M0.108 6.495L11.358 6.495 11.358 6.436 0.108 6.436z",
    mask: "url(#prefix__cV)"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#FF2146",
    d: "M0.108 6.436L11.358 6.436 11.358 6.377 0.108 6.377z",
    mask: "url(#prefix__cV)"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#FF2147",
    d: "M0.108 6.378L11.358 6.378 11.358 6.319 0.108 6.319z",
    mask: "url(#prefix__cV)"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#FF2248",
    d: "M0.108 6.319L11.358 6.319 11.358 6.26 0.108 6.26z",
    mask: "url(#prefix__cV)"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#FF2249",
    d: "M0.108 6.261L11.358 6.261 11.358 6.202 0.108 6.202z",
    mask: "url(#prefix__cV)"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#FF234A",
    d: "M0.108 6.202L11.358 6.202 11.358 6.143 0.108 6.143z",
    mask: "url(#prefix__cV)"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#FF234B",
    d: "M0.108 6.144L11.358 6.144 11.358 6.085 0.108 6.085z",
    mask: "url(#prefix__cV)"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#FF234C",
    d: "M0.108 6.085L11.358 6.085 11.358 6.026 0.108 6.026z",
    mask: "url(#prefix__cV)"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#FF244D",
    d: "M0.108 6.026L11.358 6.026 11.358 5.967 0.108 5.967z",
    mask: "url(#prefix__cV)"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#FF244E",
    d: "M0.108 5.968L11.358 5.968 11.358 5.909 0.108 5.909z",
    mask: "url(#prefix__cV)"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#FF254F",
    d: "M0.108 5.909L11.358 5.909 11.358 5.85 0.108 5.85z",
    mask: "url(#prefix__cV)"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#FF2550",
    d: "M0.108 5.851L11.358 5.851 11.358 5.792 0.108 5.792z",
    mask: "url(#prefix__cV)"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#FF2651",
    d: "M0.108 5.792L11.358 5.792 11.358 5.733 0.108 5.733z",
    mask: "url(#prefix__cV)"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#FF2652",
    d: "M0.108 5.733L11.358 5.733 11.358 5.674 0.108 5.674z",
    mask: "url(#prefix__cV)"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#FF2753",
    d: "M0.108 5.675L11.358 5.675 11.358 5.615 0.108 5.615z",
    mask: "url(#prefix__cV)"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#FF2755",
    d: "M0.108 5.615L11.358 5.615 11.358 5.556 0.108 5.556z",
    mask: "url(#prefix__cV)"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#FF2856",
    d: "M0.108 5.557L11.358 5.557 11.358 5.498 0.108 5.498z",
    mask: "url(#prefix__cV)"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#FF2857",
    d: "M0.108 5.498L11.358 5.498 11.358 5.439 0.108 5.439z",
    mask: "url(#prefix__cV)"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#FF2958",
    d: "M0.108 5.439L11.358 5.439 11.358 5.38 0.108 5.38z",
    mask: "url(#prefix__cV)"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#FF2959",
    d: "M0.108 5.381L11.358 5.381 11.358 5.322 0.108 5.322z",
    mask: "url(#prefix__cV)"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#FF2A5A",
    d: "M0.108 5.322L11.358 5.322 11.358 5.263 0.108 5.263z",
    mask: "url(#prefix__cV)"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#FF2A5B",
    d: "M0.108 5.264L11.358 5.264 11.358 5.205 0.108 5.205z",
    mask: "url(#prefix__cV)"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#FF2B5C",
    d: "M0.108 5.205L11.358 5.205 11.358 5.146 0.108 5.146z",
    mask: "url(#prefix__cV)"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#FF2B5D",
    d: "M0.108 5.146L11.358 5.146 11.358 5.087 0.108 5.087z",
    mask: "url(#prefix__cV)"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#FF2B5E",
    d: "M0.108 5.088L11.358 5.088 11.358 5.029 0.108 5.029z",
    mask: "url(#prefix__cV)"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#FF2C5F",
    d: "M0.108 5.029L11.358 5.029 11.358 4.97 0.108 4.97z",
    mask: "url(#prefix__cV)"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#FF2C60",
    d: "M0.108 4.971L11.358 4.971 11.358 4.912 0.108 4.912z",
    mask: "url(#prefix__cV)"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#FF2D61",
    d: "M0.108 4.912L11.358 4.912 11.358 4.853 0.108 4.853z",
    mask: "url(#prefix__cV)"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#FF2D62",
    d: "M0.108 4.853L11.358 4.853 11.358 4.794 0.108 4.794z",
    mask: "url(#prefix__cV)"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#FF2E63",
    d: "M0.108 4.795L11.358 4.795 11.358 4.736 0.108 4.736z",
    mask: "url(#prefix__cV)"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#FF2E64",
    d: "M0.108 4.736L11.358 4.736 11.358 4.677 0.108 4.677z",
    mask: "url(#prefix__cV)"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#FF2F65",
    d: "M0.108 4.678L11.358 4.678 11.358 4.619 0.108 4.619z",
    mask: "url(#prefix__cV)"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#FF2F66",
    d: "M0.108 4.619L11.358 4.619 11.358 4.56 0.108 4.56z",
    mask: "url(#prefix__cV)"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#FF3067",
    d: "M0.108 4.561L11.358 4.561 11.358 4.502 0.108 4.502z",
    mask: "url(#prefix__cV)"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#FF3068",
    d: "M0.108 4.502L11.358 4.502 11.358 4.443 0.108 4.443z",
    mask: "url(#prefix__cV)"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#FF3169",
    d: "M0.108 4.443L11.358 4.443 11.358 4.383 0.108 4.383z",
    mask: "url(#prefix__cV)"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#FF316A",
    d: "M0.108 4.384L11.358 4.384 11.358 4.325 0.108 4.325z",
    mask: "url(#prefix__cV)"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#FF326B",
    d: "M0.108 4.325L11.358 4.325 11.358 4.266 0.108 4.266z",
    mask: "url(#prefix__cV)"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#FF326C",
    d: "M0.108 4.267L11.358 4.267 11.358 4.208 0.108 4.208z",
    mask: "url(#prefix__cV)"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#FF326D",
    d: "M0.108 4.208L11.358 4.208 11.358 4.149 0.108 4.149z",
    mask: "url(#prefix__cV)"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#FF336E",
    d: "M0.108 4.149L11.358 4.149 11.358 4.09 0.108 4.09z",
    mask: "url(#prefix__cV)"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#FF336F",
    d: "M0.108 4.091L11.358 4.091 11.358 4.032 0.108 4.032z",
    mask: "url(#prefix__cV)"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#FF3470",
    d: "M0.108 4.032L11.358 4.032 11.358 3.973 0.108 3.973z",
    mask: "url(#prefix__cV)"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#FF3471",
    d: "M0.108 3.974L11.358 3.974 11.358 3.915 0.108 3.915z",
    mask: "url(#prefix__cV)"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#FF3572",
    d: "M0.108 3.915L11.358 3.915 11.358 3.856 0.108 3.856z",
    mask: "url(#prefix__cV)"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#FF3573",
    d: "M0.108 3.856L11.358 3.856 11.358 3.797 0.108 3.797z",
    mask: "url(#prefix__cV)"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#FF3674",
    d: "M0.108 3.798L11.358 3.798 11.358 3.739 0.108 3.739z",
    mask: "url(#prefix__cV)"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#FF3675",
    d: "M0.108 3.739L11.358 3.739 11.358 3.68 0.108 3.68z",
    mask: "url(#prefix__cV)"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#FF3776",
    d: "M0.108 3.681L11.358 3.681 11.358 3.622 0.108 3.622z",
    mask: "url(#prefix__cV)"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#FF3777",
    d: "M0.108 3.622L11.358 3.622 11.358 3.563 0.108 3.563z",
    mask: "url(#prefix__cV)"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#FF3878",
    d: "M0.108 3.563L11.358 3.563 11.358 3.504 0.108 3.504z",
    mask: "url(#prefix__cV)"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#FF3879",
    d: "M0.108 3.505L11.358 3.505 11.358 3.446 0.108 3.446z",
    mask: "url(#prefix__cV)"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#FF397A",
    d: "M0.108 3.446L11.358 3.446 11.358 3.387 0.108 3.387z",
    mask: "url(#prefix__cV)"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#FF397B",
    d: "M0.108 3.388L11.358 3.388 11.358 3.329 0.108 3.329z",
    mask: "url(#prefix__cV)"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#FF397C",
    d: "M0.108 3.329L11.358 3.329 11.358 3.27 0.108 3.27z",
    mask: "url(#prefix__cV)"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#FF3A7D",
    d: "M0.108 3.27L11.358 3.27 11.358 3.211 0.108 3.211z",
    mask: "url(#prefix__cV)"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#FF3A7E",
    d: "M0.108 3.212L11.358 3.212 11.358 3.153 0.108 3.153z",
    mask: "url(#prefix__cV)"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#FF3B7F",
    d: "M0.108 3.153L11.358 3.153 11.358 3.093 0.108 3.093z",
    mask: "url(#prefix__cV)"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#FF3B80",
    d: "M0.108 3.094L11.358 3.094 11.358 3.035 0.108 3.035z",
    mask: "url(#prefix__cV)"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#FF3C81",
    d: "M0.108 3.035L11.358 3.035 11.358 2.976 0.108 2.976z",
    mask: "url(#prefix__cV)"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#FF3C82",
    d: "M0.108 2.977L11.358 2.977 11.358 2.918 0.108 2.918z",
    mask: "url(#prefix__cV)"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#FF3D83",
    d: "M0.108 2.918L11.358 2.918 11.358 2.859 0.108 2.859z",
    mask: "url(#prefix__cV)"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#FF3D84",
    d: "M0.108 2.859L11.358 2.859 11.358 2.8 0.108 2.8z",
    mask: "url(#prefix__cV)"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#FF3E85",
    d: "M0.108 2.801L11.358 2.801 11.358 2.742 0.108 2.742z",
    mask: "url(#prefix__cV)"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#FF3E86",
    d: "M0.108 2.742L11.358 2.742 11.358 2.683 0.108 2.683z",
    mask: "url(#prefix__cV)"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#FF3F87",
    d: "M0.108 2.684L11.358 2.684 11.358 2.625 0.108 2.625z",
    mask: "url(#prefix__cV)"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#FF3F88",
    d: "M0.108 2.625L11.358 2.625 11.358 2.566 0.108 2.566z",
    mask: "url(#prefix__cV)"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#FF4089",
    d: "M0.108 2.566L11.358 2.566 11.358 2.507 0.108 2.507z",
    mask: "url(#prefix__cV)"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#FF408A",
    d: "M0.108 2.508L11.358 2.508 11.358 2.449 0.108 2.449z",
    mask: "url(#prefix__cV)"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#FF408B",
    d: "M0.108 2.449L11.358 2.449 11.358 2.39 0.108 2.39z",
    mask: "url(#prefix__cV)"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#FF418C",
    d: "M0.108 2.391L11.358 2.391 11.358 2.332 0.108 2.332z",
    mask: "url(#prefix__cV)"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#FF418D",
    d: "M0.108 2.332L11.358 2.332 11.358 2.273 0.108 2.273z",
    mask: "url(#prefix__cV)"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#FF428E",
    d: "M0.108 2.273L11.358 2.273 11.358 2.214 0.108 2.214z",
    mask: "url(#prefix__cV)"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#FF428F",
    d: "M0.108 2.215L11.358 2.215 11.358 2.156 0.108 2.156z",
    mask: "url(#prefix__cV)"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#FF4390",
    d: "M0.108 2.156L11.358 2.156 11.358 2.097 0.108 2.097z",
    mask: "url(#prefix__cV)"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#FF4391",
    d: "M0.108 2.098L11.358 2.098 11.358 2.039 0.108 2.039z",
    mask: "url(#prefix__cV)"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#FF4492",
    d: "M0.108 2.039L11.358 2.039 11.358 1.98 0.108 1.98z",
    mask: "url(#prefix__cV)"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#FF4493",
    d: "M0.108 1.98L11.358 1.98 11.358 1.921 0.108 1.921z",
    mask: "url(#prefix__cV)"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#FF4594",
    d: "M0.108 1.922L11.358 1.922 11.358 1.862 0.108 1.862z",
    mask: "url(#prefix__cV)"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#FF4595",
    d: "M0.108 1.862L11.358 1.862 11.358 1.803 0.108 1.803z",
    mask: "url(#prefix__cV)"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#FF4696",
    d: "M0.108 1.804L11.358 1.804 11.358 1.745 0.108 1.745z",
    mask: "url(#prefix__cV)"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#FF4697",
    d: "M0.108 1.745L11.358 1.745 11.358 1.686 0.108 1.686z",
    mask: "url(#prefix__cV)"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#FF4798",
    d: "M0.108 1.686L11.358 1.686 11.358 1.627 0.108 1.627z",
    mask: "url(#prefix__cV)"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#FF4799",
    d: "M0.108 1.628L11.358 1.628 11.358 1.569 0.108 1.569z",
    mask: "url(#prefix__cV)"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#FF479A",
    d: "M0.108 1.569L11.358 1.569 11.358 1.51 0.108 1.51z",
    mask: "url(#prefix__cV)"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#FF489B",
    d: "M0.108 1.511L11.358 1.511 11.358 1.452 0.108 1.452z",
    mask: "url(#prefix__cV)"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#FF489C",
    d: "M0.108 1.452L11.358 1.452 11.358 1.393 0.108 1.393z",
    mask: "url(#prefix__cV)"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#FF499D",
    d: "M0.108 1.394L11.358 1.394 11.358 1.335 0.108 1.335z",
    mask: "url(#prefix__cV)"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#FF499E",
    d: "M0.108 1.335L11.358 1.335 11.358 1.276 0.108 1.276z",
    mask: "url(#prefix__cV)"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#FF4A9F",
    d: "M0.108 1.276L11.358 1.276 11.358 1.217 0.108 1.217z",
    mask: "url(#prefix__cV)"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#FF4AA0",
    d: "M0.108 1.218L11.358 1.218 11.358 1.159 0.108 1.159z",
    mask: "url(#prefix__cV)"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#FF4BA1",
    d: "M0.108 1.159L11.358 1.159 11.358 1.1 0.108 1.1z",
    mask: "url(#prefix__cV)"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#FF4BA2",
    d: "M0.108 1.101L11.358 1.101 11.358 1.042 0.108 1.042z",
    mask: "url(#prefix__cV)"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#FF4CA3",
    d: "M0.108 1.042L11.358 1.042 11.358 0.983 0.108 0.983z",
    mask: "url(#prefix__cV)"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#FF4CA4",
    d: "M0.108 0.983L11.358 0.983 11.358 0.924 0.108 0.924z",
    mask: "url(#prefix__cV)"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#FF4DA5",
    d: "M0.108 0.925L11.358 0.925 11.358 0.866 0.108 0.866z",
    mask: "url(#prefix__cV)"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#FF4DA6",
    d: "M0.108 0.866L11.358 0.866 11.358 0.807 0.108 0.807z",
    mask: "url(#prefix__cV)"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#FF4EA7",
    d: "M0.108 0.808L11.358 0.808 11.358 0.749 0.108 0.749z",
    mask: "url(#prefix__cV)"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#FF4EA8",
    d: "M.108.749L11.358.749 11.358.69.108.69zM.108.69L11.358.69 11.358.52.108.52z",
    mask: "url(#prefix__cV)"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    fill: "#000",
    d: "M19.287.665H7.113C3.38.665.343 3.702.343 7.435V19.61c0 3.734 3.037 6.772 6.77 6.772h12.174c3.733 0 6.771-3.038 6.771-6.772V7.436c0-3.734-3.038-6.771-6.77-6.771m0 1c3.173 0 5.77 2.597 5.77 5.77V19.61c0 3.174-2.597 5.772-5.77 5.772H7.112c-3.175 0-5.77-2.598-5.77-5.772V7.436c0-3.174 2.595-5.771 5.77-5.771h12.174",
    transform: "translate(0 -1) translate(22 10.731)"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#00CBD9",
    d: "M19.315 76.127H7.085c-3.166 0-5.743-2.575-5.743-5.743v-12.23c0-3.167 2.577-5.744 5.744-5.744h12.229c3.167 0 5.744 2.578 5.744 5.745v12.228c0 3.169-2.577 5.745-5.744 5.745",
    transform: "translate(0 -1) translate(22 10.731)"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#FEFEFE",
    d: "M17.003 61.477c.504-.249.634-.719.837-1.135.054-.109-.03-.227-.029-.343.005-.28.013-.56.022-.84.002-.047-.002-.105.06-.116.054-.009.087.033.112.075.04.067.06.16.173.082.035-.024.077.011.112.032.326.191.431.616.24.94-.229.39-.423.794-.565 1.223-.179.535-.485.977-.937 1.316-.126.096-.246.1-.37-.006-.182-.156-.31-.343-.369-.578-.053-.213-.13-.416-.265-.612-.139.228-.187.476-.255.711-.138.48-.38.917-.528 1.392-.02.072-.045.143-.07.213-.07.188-.04.313.124.473.574.556.878 1.275 1.113 2.027.112.354.048.631-.23.904-.658.64-1.325 1.272-1.933 1.962-.329.374-.629.787-.729 1.267-.11.531-.242 1.078-.09 1.631.01.032.02.066.023.1.036.314-.089.414-.376.29-.253-.112-.48-.262-.674-.46-.15-.152-.249-.323-.213-.55.032-.204-.068-.369-.175-.53-.135-.205-.105-.306.1-.434.168-.104.307-.243.453-.377.521-.476.61-1.186.963-1.753.122-.195.196-.42.302-.627.205-.39.513-.686.883-.924.187-.12.182-.15.015-.298-.213-.188-.485-.28-.716-.438-.06-.04-.086-.002-.112.04-.43.681-1.115 1.105-1.67 1.66-.274.273-.573.503-.918.678-.147.074-.269.19-.372.318-.27.34-.572.648-.888.941-.395.366-.706.805-.872 1.3-.105.312-.26.58-.413.856-.116.21-.099.435-.075.661.011.1.051.221-.063.28-.117.058-.229-.003-.316-.086-.183-.174-.338-.377-.327-.639.021-.424-.087-.824-.18-1.228-.009-.034-.016-.067-.02-.1-.039-.333.03-.43.356-.414.355.018.601-.057.761-.432.16-.375.367-.734.503-1.118.214-.598.596-1.022 1.177-1.267.26-.108.407-.307.521-.548.352-.755.673-1.523.948-2.31.027-.079.025-.149.01-.234-.119-.632.011-1.22.35-1.762.158-.254.341-.493.498-.749.19-.308.086-.673.171-1 .126-.489.042-.98.042-1.47 0-.105-.02-.147-.142-.117-.253.064-.527-.012-.776.102-.09.04-.175.075-.198.185-.139.66-.35 1.308-.326 1.996.006.15.023.283.125.4.083.092.124.2.141.328.014.098.024.17-.066.23-.064.044-.1.113-.114.19-.02.104-.05.188-.185.155-.013-.003-.033-.005-.038.002-.059.071-.087.227-.219.132-.17-.124-.38-.213-.387-.493-.006-.272.001-.529.141-.77.08-.14.053-.298.025-.443-.14-.719-.024-1.432.048-2.145.012-.119.1-.19.193-.253.281-.193.561-.389.846-.578.486-.323.752-.41 1.378-.465.027-.003.06.001.081-.012.341-.212.643-.034.948.1.093.041.201.132.28.052.094-.096.133-.236.062-.38-.055-.11-.09-.229-.143-.34-.186-.404-.113-.788.095-1.157.133-.237.366-.355.618-.397.176-.03.361-.067.547-.013.098.028.21.022.293-.05.087-.076.161-.04.196.034.066.14.133.274.124.45-.01.204.11.4.135.611.012.096.034.187-.025.275-.007.011-.022.026-.018.035.123.363-.14.654-.177.987-.016.147-.086.184-.216.176-.06-.003-.125-.004-.183.012-.189.05-.243.212-.15.384.04.078.098.13.163.177.13.09.261.175.392.262.247.162.396.377.435.681.048.378-.026.75-.043 1.123-.008.18.076.34.021.54M7.22 56.583c-.3.573-.779.952-1.402 1.116-.27.07-.439-.145-.36-.406.147-.483.986-1.116 1.479-1.114.267 0 .405.17.283.404m.561-1.937c-.768-.008-1.381.359-1.994.799.144.05.217-.031.301-.078.366-.205.747-.37 1.167-.431.524-.078.807.253.638.75-.079.235-.202.443-.378.664-.126-.386-.216-.452-.597-.448-.456.004-.844.205-1.208.448-.624.416-1.166.904-1.306 1.695-.089.502.236.896.747.923.327.016.63-.055.919-.2.688-.344 1.235-.856 1.702-1.458.385-.498.721-1.025.84-1.66.109-.588-.233-1-.831-1.004",
    transform: "translate(0 -1) translate(22 10.731)"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#000",
    d: "M19.287 51.41H7.113c-3.733 0-6.77 3.039-6.77 6.772v12.174c0 3.735 3.037 6.772 6.77 6.772h12.174c3.733 0 6.771-3.037 6.771-6.772V58.182c0-3.733-3.038-6.771-6.77-6.771m0 1c3.173 0 5.77 2.598 5.77 5.77v12.175c0 3.175-2.597 5.772-5.77 5.772H7.112c-3.175 0-5.77-2.597-5.77-5.772V58.182c0-3.173 2.595-5.771 5.77-5.771h12.174",
    transform: "translate(0 -1) translate(22 10.731)"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#01B2BA",
    d: "M186.613 25.38h-12.23c-3.167 0-5.744-2.576-5.744-5.744V7.408c0-3.168 2.577-5.745 5.744-5.745h12.23c3.167 0 5.744 2.577 5.744 5.745v12.228c0 3.168-2.577 5.744-5.744 5.744",
    transform: "translate(0 -1) translate(22 10.731)"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#FBFDFD",
    d: "M186.655 15.072c-.856 0-1.554-.687-1.569-1.541-.015-.824.708-1.563 1.547-1.58.85-.016 1.584.717 1.584 1.58-.003.847-.707 1.54-1.563 1.54M183.354 14.908c-.776-.01-1.373-.612-1.374-1.387-.001-.771.645-1.42 1.41-1.413.75.006 1.416.679 1.41 1.429-.006.758-.663 1.38-1.446 1.37M183.365 11.586c-.759-.004-1.353-.604-1.346-1.359.006-.732.644-1.359 1.376-1.351.74.006 1.33.623 1.33 1.383-.003.77-.574 1.329-1.36 1.327M184.725 16.807c-.001.771-.573 1.336-1.354 1.334-.762 0-1.355-.595-1.351-1.355.003-.732.637-1.359 1.37-1.357.733.003 1.335.623 1.335 1.378M178.956 13.527c-.005-.698.533-1.248 1.228-1.251.695-.004 1.247.535 1.26 1.23.011.68-.552 1.25-1.242 1.26-.695.008-1.24-.534-1.246-1.24",
    transform: "translate(0 -1) translate(22 10.731)"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#F9FCFD",
    d: "M180.2 9.042c.668.004 1.215.563 1.202 1.23-.012.643-.57 1.184-1.217 1.182-.645-.003-1.227-.6-1.21-1.242.018-.64.574-1.171 1.224-1.17M181.403 16.815c-.006.634-.573 1.197-1.205 1.197-.65 0-1.228-.585-1.222-1.232.006-.65.59-1.2 1.256-1.185.646.016 1.178.57 1.17 1.22M179.044 20.058c.003-.647.518-1.15 1.17-1.143.636.01 1.147.547 1.133 1.191-.014.615-.543 1.132-1.156 1.13-.635-.005-1.15-.533-1.147-1.178",
    transform: "translate(0 -1) translate(22 10.731)"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#FBFDFD",
    d: "M179.044 6.936c.007-.644.527-1.139 1.184-1.125.62.013 1.122.53 1.121 1.156 0 .637-.538 1.166-1.17 1.153-.646-.015-1.142-.532-1.135-1.184",
    transform: "translate(0 -1) translate(22 10.731)"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#F9FCFD",
    d: "M176.984 12.431c.582.005 1.082.505 1.087 1.087.005.58-.544 1.12-1.126 1.106-.593-.012-1.084-.539-1.071-1.147.013-.6.492-1.05 1.11-1.046M176.96 9.207c.61-.002 1.04.427 1.037 1.036 0 .587-.466 1.062-1.036 1.06-.56 0-1.049-.491-1.057-1.06-.008-.573.462-1.035 1.056-1.036M176.95 15.761c.614-.004 1.044.417 1.047 1.026.003.59-.452 1.063-1.026 1.07-.558.006-1.054-.483-1.067-1.05-.014-.575.453-1.04 1.046-1.046M173.716 14.46c-.516-.01-.945-.45-.936-.959.01-.497.469-.938.97-.93.514.008.93.443.926.965-.005.508-.447.934-.96.924",
    transform: "translate(0 -1) translate(22 10.731)"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#000",
    d: "M186.585.665h-12.174c-3.733 0-6.77 3.037-6.77 6.77V19.61c0 3.734 3.037 6.772 6.77 6.772h12.174c3.733 0 6.771-3.038 6.771-6.772V7.436c0-3.734-3.038-6.771-6.77-6.771m0 1c3.174 0 5.77 2.597 5.77 5.77V19.61c0 3.174-2.596 5.772-5.77 5.772H174.41c-3.174 0-5.77-2.598-5.77-5.772V7.436c0-3.174 2.596-5.771 5.77-5.771h12.174",
    transform: "translate(0 -1) translate(22 10.731)"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(0 -1) translate(226 37.731)"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "prefix__cX",
    fill: "#fff"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#prefix__cW"
  })), /*#__PURE__*/React.createElement("path", {
    fill: "#E2E2E2",
    d: "M0.043 23.754L0.143 23.754 0.143 0.037 0.043 0.037z",
    mask: "url(#prefix__cX)"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#E3E3E3",
    d: "M0.143 23.754L0.549 23.754 0.549 0.037 0.143 0.037z",
    mask: "url(#prefix__cX)"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#E4E4E4",
    d: "M0.549 23.754L0.955 23.754 0.955 0.037 0.549 0.037z",
    mask: "url(#prefix__cX)"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#E5E5E5",
    d: "M0.956 23.754L1.362 23.754 1.362 0.037 0.956 0.037z",
    mask: "url(#prefix__cX)"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#E6E6E6",
    d: "M1.362 23.754L1.768 23.754 1.768 0.037 1.362 0.037z",
    mask: "url(#prefix__cX)"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#E7E7E7",
    d: "M1.768 23.754L2.174 23.754 2.174 0.037 1.768 0.037z",
    mask: "url(#prefix__cX)"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#E8E8E8",
    d: "M2.174 23.754L2.58 23.754 2.58 0.037 2.174 0.037z",
    mask: "url(#prefix__cX)"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#E9E9E9",
    d: "M2.581 23.754L2.987 23.754 2.987 0.037 2.581 0.037z",
    mask: "url(#prefix__cX)"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#EAEAEA",
    d: "M2.987 23.754L3.393 23.754 3.393 0.037 2.987 0.037z",
    mask: "url(#prefix__cX)"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#EBEBEB",
    d: "M3.393 23.754L3.799 23.754 3.799 0.037 3.393 0.037z",
    mask: "url(#prefix__cX)"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#ECECEC",
    d: "M3.799 23.754L4.205 23.754 4.205 0.037 3.799 0.037z",
    mask: "url(#prefix__cX)"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#EDEDED",
    d: "M4.206 23.754L4.612 23.754 4.612 0.037 4.206 0.037z",
    mask: "url(#prefix__cX)"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#EEE",
    d: "M4.612 23.754L5.018 23.754 5.018 0.037 4.612 0.037z",
    mask: "url(#prefix__cX)"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#EFEFEF",
    d: "M5.018 23.754L5.424 23.754 5.424 0.037 5.018 0.037z",
    mask: "url(#prefix__cX)"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#F1F1F1",
    d: "M5.424 23.754L5.83 23.754 5.83 0.037 5.424 0.037z",
    mask: "url(#prefix__cX)"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#F2F2F2",
    d: "M5.831 23.754L6.237 23.754 6.237 0.037 5.831 0.037z",
    mask: "url(#prefix__cX)"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#F3F3F3",
    d: "M6.237 23.754L6.643 23.754 6.643 0.037 6.237 0.037z",
    mask: "url(#prefix__cX)"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#F4F4F4",
    d: "M6.643 23.754L7.049 23.754 7.049 0.037 6.643 0.037z",
    mask: "url(#prefix__cX)"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#F5F5F5",
    d: "M7.049 23.754L7.455 23.754 7.455 0.037 7.049 0.037z",
    mask: "url(#prefix__cX)"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#F6F6F6",
    d: "M7.456 23.754L7.862 23.754 7.862 0.037 7.456 0.037z",
    mask: "url(#prefix__cX)"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#F7F7F7",
    d: "M7.862 23.754L8.268 23.754 8.268 0.037 7.862 0.037z",
    mask: "url(#prefix__cX)"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#F8F8F8",
    d: "M8.268 23.754L8.674 23.754 8.674 0.037 8.268 0.037z",
    mask: "url(#prefix__cX)"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#F9F9F9",
    d: "M8.674 23.754L9.08 23.754 9.08 0.037 8.674 0.037z",
    mask: "url(#prefix__cX)"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#FAFAFA",
    d: "M9.081 23.754L9.487 23.754 9.487 0.037 9.081 0.037z",
    mask: "url(#prefix__cX)"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#FBFBFB",
    d: "M9.487 23.754L9.893 23.754 9.893 0.037 9.487 0.037z",
    mask: "url(#prefix__cX)"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#FCFCFC",
    d: "M9.893 23.754L10.299 23.754 10.299 0.037 9.893 0.037z",
    mask: "url(#prefix__cX)"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#FDFDFD",
    d: "M10.299 23.754L10.705 23.754 10.705 0.037 10.299 0.037z",
    mask: "url(#prefix__cX)"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#FEFEFE",
    d: "M10.706 23.754L11.112 23.754 11.112 0.037 10.706 0.037z",
    mask: "url(#prefix__cX)"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#FFF",
    d: "M11.112 23.754L11.518 23.754 11.518.037 11.112.037zM11.518 23.754L11.924 23.754 11.924.037 11.518.037z",
    mask: "url(#prefix__cX)"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#FEFEFE",
    d: "M11.924 23.754L12.33 23.754 12.33 0.037 11.924 0.037z",
    mask: "url(#prefix__cX)"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#FDFDFD",
    d: "M12.331 23.754L12.737 23.754 12.737 0.037 12.331 0.037z",
    mask: "url(#prefix__cX)"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#FCFCFC",
    d: "M12.737 23.754L13.143 23.754 13.143 0.037 12.737 0.037z",
    mask: "url(#prefix__cX)"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#FBFBFB",
    d: "M13.143 23.754L13.549 23.754 13.549 0.037 13.143 0.037z",
    mask: "url(#prefix__cX)"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#FAFAFA",
    d: "M13.549 23.754L13.955 23.754 13.955 0.037 13.549 0.037z",
    mask: "url(#prefix__cX)"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#F9F9F9",
    d: "M13.956 23.754L14.362 23.754 14.362 0.037 13.956 0.037z",
    mask: "url(#prefix__cX)"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#F8F8F8",
    d: "M14.362 23.754L14.768 23.754 14.768 0.037 14.362 0.037z",
    mask: "url(#prefix__cX)"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#F7F7F7",
    d: "M14.768 23.754L15.174 23.754 15.174 0.037 14.768 0.037z",
    mask: "url(#prefix__cX)"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#F6F6F6",
    d: "M15.174 23.754L15.58 23.754 15.58 0.037 15.174 0.037z",
    mask: "url(#prefix__cX)"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#F5F5F5",
    d: "M15.581 23.754L15.987 23.754 15.987 0.037 15.581 0.037z",
    mask: "url(#prefix__cX)"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#F4F4F4",
    d: "M15.987 23.754L16.394 23.754 16.394 0.037 15.987 0.037z",
    mask: "url(#prefix__cX)"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#F3F3F3",
    d: "M16.394 23.754L16.8 23.754 16.8 0.037 16.394 0.037z",
    mask: "url(#prefix__cX)"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#F2F2F2",
    d: "M16.8 23.754L17.206 23.754 17.206 0.037 16.8 0.037z",
    mask: "url(#prefix__cX)"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#F1F1F1",
    d: "M17.207 23.754L17.613 23.754 17.613 0.037 17.207 0.037z",
    mask: "url(#prefix__cX)"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#EFEFEF",
    d: "M17.613 23.754L18.019 23.754 18.019 0.037 17.613 0.037z",
    mask: "url(#prefix__cX)"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#EEE",
    d: "M18.019 23.754L18.425 23.754 18.425 0.037 18.019 0.037z",
    mask: "url(#prefix__cX)"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#EDEDED",
    d: "M18.425 23.754L18.831 23.754 18.831 0.037 18.425 0.037z",
    mask: "url(#prefix__cX)"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#ECECEC",
    d: "M18.832 23.754L19.238 23.754 19.238 0.037 18.832 0.037z",
    mask: "url(#prefix__cX)"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#EBEBEB",
    d: "M19.238 23.754L19.644 23.754 19.644 0.037 19.238 0.037z",
    mask: "url(#prefix__cX)"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#EAEAEA",
    d: "M19.644 23.754L20.05 23.754 20.05 0.037 19.644 0.037z",
    mask: "url(#prefix__cX)"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#E9E9E9",
    d: "M20.05 23.754L20.456 23.754 20.456 0.037 20.05 0.037z",
    mask: "url(#prefix__cX)"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#E8E8E8",
    d: "M20.457 23.754L20.863 23.754 20.863 0.037 20.457 0.037z",
    mask: "url(#prefix__cX)"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#E7E7E7",
    d: "M20.863 23.754L21.269 23.754 21.269 0.037 20.863 0.037z",
    mask: "url(#prefix__cX)"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#E6E6E6",
    d: "M21.269 23.754L21.675 23.754 21.675 0.037 21.269 0.037z",
    mask: "url(#prefix__cX)"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#E5E5E5",
    d: "M21.675 23.754L22.081 23.754 22.081 0.037 21.675 0.037z",
    mask: "url(#prefix__cX)"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#E4E4E4",
    d: "M22.082 23.754L22.488 23.754 22.488 0.037 22.082 0.037z",
    mask: "url(#prefix__cX)"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#E3E3E3",
    d: "M22.488 23.754L22.894 23.754 22.894 0.037 22.488 0.037z",
    mask: "url(#prefix__cX)"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#E2E2E2",
    d: "M22.894 23.754L23.3 23.754 23.3.037 22.894.037zM23.3 23.755L23.76 23.755 23.76.038 23.3.038z",
    mask: "url(#prefix__cX)"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    fill: "#000",
    d: "M20.766 32.647v12.497l-7.103-4.254c1.124-.675 2.219-1.331 3.372-2.02v.371c0 .433-.003.867.002 1.301 0 .066.016.166.06.193.539.334 1.084.657 1.654 1v-5.673c-.093.052-.171.091-.244.135-1.802 1.079-3.604 2.156-5.402 3.242-.154.093-.26.093-.414 0-1.79-1.081-3.586-2.154-5.381-3.229l-.256-.15v5.669c.555-.334 1.094-.653 1.625-.984.05-.032.076-.137.077-.208.007-.458.003-.916.004-1.374 0-.079.008-.157.014-.284l3.358 2.01-7.095 4.25V32.66c.083.044.16.081.233.125 2.475 1.482 4.95 2.963 7.422 4.451.155.093.26.09.414-.002 2.457-1.48 4.919-2.952 7.38-4.426.082-.05.167-.096.28-.161",
    transform: "translate(0 -1) translate(225 10.731)"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#000",
    d: "M18.988 26.038H6.814c-3.732 0-6.77 3.037-6.77 6.77v12.175c0 3.734 3.038 6.772 6.77 6.772h12.174c3.733 0 6.771-3.038 6.771-6.772V32.809c0-3.734-3.038-6.771-6.77-6.771m0 1c3.174 0 5.77 2.597 5.77 5.77v12.175c0 3.174-2.596 5.772-5.77 5.772H6.813c-3.174 0-5.77-2.598-5.77-5.772V32.809c0-3.174 2.596-5.771 5.77-5.771h12.174M54.42 25.38H42.19c-3.168 0-5.745-2.576-5.745-5.744V7.408c0-3.168 2.577-5.745 5.745-5.745H54.42c3.168 0 5.744 2.577 5.744 5.745v12.228c0 3.168-2.576 5.744-5.744 5.744",
    transform: "translate(0 -1) translate(225 10.731)"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#D10027",
    d: "M40.866 10.028c.168-.302.3-.57.46-.818 1.411-2.2 3.408-3.508 6.003-3.832 4.421-.554 8.457 2.557 9.1 6.975.644 4.442-2.432 8.608-6.856 9.282-4.326.66-8.369-2.125-9.297-6.41-.197-.91-.228-1.828-.112-2.753.02-.157.074-.193.224-.192 2.905.004 5.81 0 8.713.004.528 0 .925-.22 1.168-.684.39-.741-.102-1.56-.939-1.57-.72-.01-1.44-.002-2.159-.002h-6.305z",
    transform: "translate(0 -1) translate(225 10.731)"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#BA0D2F",
    d: "M55.592 9.746c.043.742-.07 1.553-.472 2.367-1.392 2.819-3.31 3.786-6.367 3.786h-5.187s-.687-.34-1.264 1.019c-.263.618-.478 1.096-.633 1.432 1.756 2.42 4.755 3.765 7.904 3.286 4.424-.675 7.5-4.841 6.855-9.283-.136-.935-.424-1.811-.836-2.607",
    transform: "translate(0 -1) translate(225 10.731)"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#000",
    d: "M54.392.665H42.218c-3.733 0-6.771 3.037-6.771 6.77V19.61c0 3.734 3.038 6.772 6.77 6.772h12.175c3.733 0 6.77-3.038 6.77-6.772V7.436c0-3.734-3.037-6.771-6.77-6.771m0 1c3.175 0 5.77 2.597 5.77 5.77V19.61c0 3.174-2.595 5.772-5.77 5.772H42.218c-3.174 0-5.771-2.598-5.771-5.772V7.436c0-3.174 2.597-5.771 5.77-5.771h12.175",
    transform: "translate(0 -1) translate(225 10.731)"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(0 -1) translate(261 62.731)"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "prefix__cZ",
    fill: "#fff"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#prefix__cY"
  })), /*#__PURE__*/React.createElement("path", {
    fill: "#FF7500",
    d: "M.447.41v23.718V.41z",
    mask: "url(#prefix__cZ)"
  }), /*#__PURE__*/React.createElement("mask", {
    id: "prefix__db",
    fill: "#fff"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#prefix__da"
  })), /*#__PURE__*/React.createElement("path", {
    fill: "#FF7500",
    d: "M0.447 24.127L0.941 24.127 0.941 0.41 0.447 0.41z",
    mask: "url(#prefix__db)"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#FF7400",
    d: "M0.941 24.127L1.435 24.127 1.435 0.41 0.941 0.41z",
    mask: "url(#prefix__db)"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#FF7300",
    d: "M1.435 24.127L1.929 24.127 1.929 0.41 1.435 0.41z",
    mask: "url(#prefix__db)"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#FF7200",
    d: "M1.929 24.127L2.423 24.127 2.423 0.41 1.929 0.41z",
    mask: "url(#prefix__db)"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#FF7100",
    d: "M2.423 24.127L2.917 24.127 2.917 0.41 2.423 0.41z",
    mask: "url(#prefix__db)"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#FF7000",
    d: "M2.917 24.127L3.411 24.127 3.411 0.41 2.917 0.41z",
    mask: "url(#prefix__db)"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#FF6F00",
    d: "M3.411 24.127L3.905 24.127 3.905 0.41 3.411 0.41z",
    mask: "url(#prefix__db)"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#FF6E00",
    d: "M3.906 24.127L4.4 24.127 4.4 0.41 3.906 0.41z",
    mask: "url(#prefix__db)"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#FF6D00",
    d: "M4.4 24.127L4.894 24.127 4.894 0.41 4.4 0.41z",
    mask: "url(#prefix__db)"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#FF6C00",
    d: "M4.894 24.127L5.388 24.127 5.388 0.41 4.894 0.41z",
    mask: "url(#prefix__db)"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#FF6B00",
    d: "M5.388 24.127L5.882 24.127 5.882 0.41 5.388 0.41z",
    mask: "url(#prefix__db)"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#FF6A00",
    d: "M5.882 24.127L6.376 24.127 6.376 0.41 5.882 0.41z",
    mask: "url(#prefix__db)"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#FF6900",
    d: "M6.376 24.127L6.87 24.127 6.87 0.41 6.376 0.41z",
    mask: "url(#prefix__db)"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#FF6800",
    d: "M6.87 24.127L7.364 24.127 7.364 0.41 6.87 0.41z",
    mask: "url(#prefix__db)"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#FF6700",
    d: "M7.365 24.127L7.859 24.127 7.859 0.41 7.365 0.41z",
    mask: "url(#prefix__db)"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#F60",
    d: "M7.859 24.127L8.353 24.127 8.353 0.41 7.859 0.41z",
    mask: "url(#prefix__db)"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#FF6500",
    d: "M8.353 24.127L8.847 24.127 8.847 0.41 8.353 0.41z",
    mask: "url(#prefix__db)"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#FF6400",
    d: "M8.847 24.127L9.341 24.127 9.341 0.41 8.847 0.41z",
    mask: "url(#prefix__db)"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#FF6300",
    d: "M9.341 24.127L9.834 24.127 9.834 0.41 9.341 0.41z",
    mask: "url(#prefix__db)"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#FF6200",
    d: "M9.834 24.127L10.328 24.127 10.328 0.41 9.834 0.41z",
    mask: "url(#prefix__db)"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#FF6100",
    d: "M10.328 24.127L10.822 24.127 10.822 0.41 10.328 0.41z",
    mask: "url(#prefix__db)"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#FF6000",
    d: "M10.823 24.127L11.317 24.127 11.317 0.41 10.823 0.41z",
    mask: "url(#prefix__db)"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#FF5F00",
    d: "M11.317 24.127L11.811 24.127 11.811 0.41 11.317 0.41z",
    mask: "url(#prefix__db)"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#FF5E00",
    d: "M11.811 24.127L12.305 24.127 12.305 0.41 11.811 0.41z",
    mask: "url(#prefix__db)"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#FF5C00",
    d: "M12.305 24.127L12.799 24.127 12.799 0.41 12.305 0.41z",
    mask: "url(#prefix__db)"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#FF5B00",
    d: "M12.799 24.127L13.293 24.127 13.293 0.41 12.799 0.41z",
    mask: "url(#prefix__db)"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#FF5A00",
    d: "M13.293 24.127L13.787 24.127 13.787 0.41 13.293 0.41z",
    mask: "url(#prefix__db)"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#FF5900",
    d: "M13.787 24.127L14.281 24.127 14.281 0.41 13.787 0.41z",
    mask: "url(#prefix__db)"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#FF5800",
    d: "M14.282 24.127L14.776 24.127 14.776 0.41 14.282 0.41z",
    mask: "url(#prefix__db)"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#FF5700",
    d: "M14.776 24.127L15.27 24.127 15.27 0.41 14.776 0.41z",
    mask: "url(#prefix__db)"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#FF5600",
    d: "M15.27 24.127L15.764 24.127 15.764 0.41 15.27 0.41z",
    mask: "url(#prefix__db)"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#F50",
    d: "M15.764 24.127L16.258 24.127 16.258 0.41 15.764 0.41z",
    mask: "url(#prefix__db)"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#FF5400",
    d: "M16.258 24.127L16.752 24.127 16.752 0.41 16.258 0.41z",
    mask: "url(#prefix__db)"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#FF5300",
    d: "M16.752 24.127L17.246 24.127 17.246 0.41 16.752 0.41z",
    mask: "url(#prefix__db)"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#FF5200",
    d: "M17.246 24.127L17.74 24.127 17.74 0.41 17.246 0.41z",
    mask: "url(#prefix__db)"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#FF5100",
    d: "M17.741 24.127L18.235 24.127 18.235 0.41 17.741 0.41z",
    mask: "url(#prefix__db)"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#FF5000",
    d: "M18.235 24.127L18.729 24.127 18.729 0.41 18.235 0.41z",
    mask: "url(#prefix__db)"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#FF4F00",
    d: "M18.729 24.127L19.223 24.127 19.223 0.41 18.729 0.41z",
    mask: "url(#prefix__db)"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#FF4E00",
    d: "M19.223 24.127L19.717 24.127 19.717 0.41 19.223 0.41z",
    mask: "url(#prefix__db)"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#FF4D00",
    d: "M19.717 24.127L20.211 24.127 20.211 0.41 19.717 0.41z",
    mask: "url(#prefix__db)"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#FF4C00",
    d: "M20.211 24.127L20.705 24.127 20.705 0.41 20.211 0.41z",
    mask: "url(#prefix__db)"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#FF4B00",
    d: "M20.705 24.127L21.199 24.127 21.199 0.41 20.705 0.41z",
    mask: "url(#prefix__db)"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#FF4A00",
    d: "M21.2 24.127L21.693 24.127 21.693 0.41 21.2 0.41z",
    mask: "url(#prefix__db)"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#FF4900",
    d: "M21.693 24.127L22.187 24.127 22.187 0.41 21.693 0.41z",
    mask: "url(#prefix__db)"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#FF4800",
    d: "M22.187 24.127L22.681 24.127 22.681 0.41 22.187 0.41z",
    mask: "url(#prefix__db)"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#FF4700",
    d: "M22.681 24.127L23.175 24.127 23.175 0.41 22.681 0.41z",
    mask: "url(#prefix__db)"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#FF4600",
    d: "M23.175 24.127L23.669 24.127 23.669 0.41 23.175 0.41z",
    mask: "url(#prefix__db)"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#FF4500",
    d: "M23.669 24.127L24.163 24.127 24.163.41 23.669.41zM24.163 24.128V.41v23.718z",
    mask: "url(#prefix__db)"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    fill: "#F8F8F8",
    d: "M12.069 10.287L14.239 14.637 17.549 14.637 12.069 3.645 6.59 14.637 9.9 14.637z",
    transform: "translate(0 -1) translate(260 61.731)"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#FFA678",
    d: "M15.905 17.904L14.274 14.636 11.787 14.636 15.905 22.893 20.02 14.636 17.534 14.636z",
    transform: "translate(0 -1) translate(260 61.731)"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#000",
    d: "M19.392.41H7.218C3.485.41.447 3.45.447 7.183v12.174c0 3.735 3.038 6.772 6.77 6.772h12.175c3.733 0 6.77-3.037 6.77-6.772V7.182c0-3.733-3.037-6.771-6.77-6.771m0 1c3.175 0 5.77 2.598 5.77 5.77v12.175c0 3.175-2.595 5.772-5.77 5.772H7.218c-3.174 0-5.771-2.597-5.771-5.772V7.182c0-3.173 2.597-5.771 5.77-5.771h12.175",
    transform: "translate(0 -1) translate(260 61.731)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIllHowtotrack2);
export default __webpack_public_path__ + "static/media/ill_howtotrack2.b0a59d14371da9ed4f4eee70d3635e01.svg";
export { ForwardRef as ReactComponent };